import React from 'react';
import Select from 'react-select';
import 'assets/scss/finding-list.scss';
import { MagicSpinner } from 'react-spinners-kit';
import { ToastContainer, toast } from 'react-toastify';
import {
  Card,
  CardHeader,
  CardBody,
  Table,
  Row,
  Col,
  Button,
  CardFooter,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  UncontrolledTooltip,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Pagination,
  PaginationItem,
  PaginationLink,
} from 'reactstrap';

import FindingDetailModal from './FindingDetailModal';
import IgnoreVulnModal from './IgnoreVulnModal';
import StatusDetails from './status_details';
import UnignoreVulnModal from './UnignoreVulnModal';
import NoRecordFound from '../../../components/NoRecordFound/NoRecordFound';
import { SeverityColor } from '../../../components/Styles/Filter';

import 'react-toastify/dist/ReactToastify.css';
import DatePicker from 'react-datepicker';

import '@y0c/react-datepicker/assets/styles/calendar.scss';
import moment from 'moment';
import { Editor, EditorState, RichUtils, convertToRaw } from 'draft-js';
import 'draft-js/dist/Draft.css';
import { draftToMarkdown } from 'markdown-draft-js';
import debounce from 'lodash.debounce';
import CustomMultiSelect from 'components/CustomMultiSelect';
import InfiniteSelect from 'components/InfiniteSelect';
import StatusMultiSelect from 'components/StatusMultiSelect';
import ModalDialog from 'components/ModalDialog';
import callApi from 'lib/callApi';
import _ from 'lodash';
import { getQueryParams, fetchHosts } from 'lib/helper';
import TableWithStickyHeader from 'components/TableWithStickyHeader';
import FileDownloaderButton from 'components/FileDownloaderButton';
import Markdown from 'components/Markdown';

const styleMap = {
  CODE: {
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
    fontSize: 16,
    padding: 2,
  },
};

function getBlockStyle(block) {
  switch (block.getType()) {
    case 'blockquote':
      return 'RichEditor-blockquote';
    default:
      return null;
  }
}

class StyleButton extends React.Component {
  constructor() {
    super();
    this.onToggle = (e) => {
      e.preventDefault();
      this.props.onToggle(this.props.style);
    };
  }

  render() {
    let className = 'RichEditor-styleButton';
    if (this.props.active) {
      className += ' RichEditor-activeButton';
    }

    return (
      <span className={className} onMouseDown={this.onToggle}>
        {this.props.label}
      </span>
    );
  }
}

const BLOCK_TYPES = [
  { label: 'H1', style: 'header-one' },
  { label: 'H2', style: 'header-two' },
  { label: 'H3', style: 'header-three' },
  { label: 'H4', style: 'header-four' },
  { label: 'H5', style: 'header-five' },
  { label: 'H6', style: 'header-six' },
  { label: 'Blockquote', style: 'blockquote' },
  { label: 'UL', style: 'unordered-list-item' },
  { label: 'OL', style: 'ordered-list-item' },
  { label: 'Code Block', style: 'code-block' },
];

const BlockStyleControls = (props) => {
  const { editorState } = props;
  const selection = editorState.getSelection();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();

  return (
    <div className="RichEditor-controls">
      {BLOCK_TYPES.map((type) => (
        <StyleButton
          key={type.label}
          active={type.style === blockType}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
        />
      ))}
    </div>
  );
};

var INLINE_STYLES = [
  { label: 'Bold', style: 'BOLD' },
  { label: 'Italic', style: 'ITALIC' },
  { label: 'Underline', style: 'UNDERLINE' },
  { label: 'Monospace', style: 'CODE' },
];

const InlineStyleControls = (props) => {
  var currentStyle = props.editorState.getCurrentInlineStyle();
  return (
    <div className="RichEditor-controls">
      {INLINE_STYLES.map((type) => (
        <StyleButton
          key={type.label}
          active={currentStyle.has(type.style)}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
        />
      ))}
    </div>
  );
};

// import calendar style
const colourStyles = {
  control: (styles) => ({
    ...styles,
    // backgroundColor: 'white'
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    // const color = chroma(data.color);
    return {
      ...styles,
      textAlign: 'left',
    };
  },
  menu: (base) => ({
    ...base,
    width: 'max-content',
    minWidth: '100%',
  }),
};
const memberStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: '#FFFFFF',
    marginLeft: 'auto',
    theme: 'primary',
    marginRight: 'auto',
    border: '1px solid #CCCCCC',
    borderRadius: '50%',
    padding: '0px',
    width: '40px',
    height: '40px',
  }),
  container: (styles) => ({
    ...styles,
    border: '0px solid #FFFFFF',
    padding: '3px',
  }),
  input: (styles) => ({ ...styles, border: '0px solid #FFFFFF' }),
  indicatorsContainer: (styles) => ({
    ...styles,
    border: '0px solid #FFFFFF',
    display: 'none',
  }),
  placeholder: (styles) => ({
    ...styles,
    border: '0px solid #FFFFFF',
    backgroundColor: 'transparent',
  }),
  valueContainer: (styles) => ({ ...styles, border: '0px solid #FFFFFF' }),
  menuList: (styles) => ({ ...styles, minWidth: '150px' }),
  menu: (styles) => ({ ...styles, minWidth: '150px' }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    // const color = chroma(data.color);
    return {
      ...styles,
      textAlign: 'left',
    };
  },
};
const slimColourStyles = {
  // menu: (provided, state) => ({
  //     ...provided,
  //     width: state.selectProps.width,
  //     // borderBottom: '1px dotted pink',
  //     // color: state.selectProps.menuColor,
  //     // padding: 20,
  // }),
  control: (styles) => ({
    ...styles,
    // backgroundColor: 'white',
    paddint: '5px',
    maxHeight: '50px',
    // maxWidth: '100px',
    marginLeft: 'auto',
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    // const color = chroma(data.color);
    return {
      ...styles,
      textAlign: 'left',
    };
  },
};
const SeverityList = {
  5: 'Urgent',
  4: 'Critical',
  3: 'Serious',
  2: 'Medium',
  1: 'Minimal',
};

const severities = [
  { value: '', label: 'All' },
  { value: '5', label: 'Urgent' },
  { value: '4', label: 'Critical' },
  { value: '3', label: 'Serious' },
  { value: '2', label: 'Medium' },
  { value: '1', label: 'Minimal' },
];
const ISSUE_TYPES = [
  { value: '', label: 'All' },
  { value: 'VULNERABILITY', label: 'Vulnerability' },
  // { value: "BUG", label: "Bugs" },
  // { value: "CODE_SMELL", label: "BP Violation" },
];
const SAST_ISSUE_TYPES = [
  { value: '', label: 'All' },
  { value: 'VULNERABILITY', label: 'Vulnerability' },
  { value: 'BUG', label: 'Bugs' },
];
const CATEGORIES = [
  { value: '', label: 'All' },
  { value: '&knowledge_base__patchable=1', label: 'Patchable' },
  { value: '&knowledge_base__patchable=0', label: 'Non Patchable' },
  { value: '&severity__in=5,4', label: 'High Severity' },
  { value: '&title__icontains=Obsolete', label: 'Obsolete' },
  { value: '&assigned=true', label: 'Assigned' },
  { value: '&self_assigned=true', label: 'Assigned To Me' },
  { value: '&watching=true', label: 'Watching' },
  { value: '&zero_day=true', label: 'Zero Day' },
];
const NON_QUALYS_CATEGORIES = [
  { value: '', label: 'All' },
  { value: '&severity__in=5,4', label: 'High Severity' },
  { value: '&assigned=true', label: 'Assigned' },
  { value: '&watching=true', label: 'Watching' },
];
const StatusOptions = [
  { value: 'all', label: 'All' },
  { value: 'open', label: 'All Open' },
  { value: 'new', label: '\u00A0\u00A0 New (Last Scan)' },
  { value: 'active', label: '\u00A0\u00A0 Active' },
  { value: 'reopened', label: '\u00A0\u00A0 Reopened (Last Scan)' },
  { value: 'closed', label: 'All Closed' },
  { value: 'fixed', label: '\u00A0\u00A0 Fixed' },
  { value: 'ignored', label: '\u00A0\u00A0 Ignored' },
];

const SourceType = [
  { value: '', label: 'All' },
  { value: 'was_data', label: 'Web Apps' },
  { value: 'sast2', label: 'SAST' },
  { value: 'endpoint_data', label: 'Endpoints - All' },
  { value: 'endpoint_data_external', label: 'Endpoints - External' },
  { value: 'endpoint_data_internal', label: 'Endpoints - Internal' },
  { value: 'endpoint_data_ec2', label: 'Endpoints - AWS' },
  { value: 'ca_data-all', label: 'Cloud Agents - All' },
  { value: 'ca_data', label: 'Cloud Agents - Servers', subtype: 'servers' },
  {
    value: 'ca_data-workstations',
    label: 'Cloud Agents - Workstations',
    subtype: 'workstations',
  },
  // { value: "bpr", label: "Cloud BPA" },
];

const HOSTS_LIMIT = 100;
const PAGE_SIZES = [
  { value: '25', label: '25' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
  { value: '200', label: '200' },
];

const DEFAULT_ORDERING = '-severity,-last_detected_date';
const FIXED_VULN_ORDERING_1 = '-last_detected_date';
// FIXED VULN VIEW default secondary sort order for endpoints listing
const FIXED_VULN_ORDERING_2_FOR_EP = 'big_ip';
// FIXED VULN VIEW default secondary sort order for non endpoint listing
const FIXED_VULN_ORDERING_2_FOR_NON_EP = 'url,cloud_agent_name,endpoint_name';
const INV_FIXED_VULN_ORDERING_2_FOR_NON_EP =
  '-url,-cloud_agent_name,-endpoint_name';

class FindingList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reports: [],
      modal: false,
      notesmodal: false,
      notes: [],
      watcher_modal: false,
      watchers: [],
      currentReport: {},
      currentData: {},
      tagData: [],
      hostapps: [],
      // TODO: rename as it will be an array of items instead one item
      current_host: null,
      searchValue: '',
      source_type: { value: 'was_data', label: 'Web Apps' }, //{ value: "", label: "All" },
      currentTag: {},
      selectedTags: [],
      company_search_data: '',
      qid: '',
      rule_id: '',
      openModal: false,
      loader: true,
      currentPage: 0,
      pageSize: 25.0,
      ordering: DEFAULT_ORDERING,
      issue_type: 'VULNERABILITY',
      statuses: [{ value: 'open', label: 'All Open' }],
      selectedSeverityOption: { value: '', label: 'All' },
      selectedIssueTypeOption: {
        value: 'VULNERABILITY',
        label: 'Vulnerability',
      },
      selectedCategoryOption: { value: '', label: 'All' },
      webapp: '',
      endpoint: '',
      current_note: '',
      members: [],
      watchers_options: [],
      show_ignore_vuln_modal: false,
      unignore_vuln_modal: false,
      advance_search_modal: false,
      advance_search_filters_count: 0,
      last_detected_from_date: null,
      last_detected_to_date: null,
      last_tested_from_date: null,
      last_tested_to_date: null,
      due_from_date: null,
      due_to_date: null,
      ignored_reason: { value: 'FALSE_POSITIVE', label: 'False Positive' },
      ignored_comments: '',
      editorState: EditorState.createEmpty(),
      scanner_type: null,
      created_from_date: null,
      created_to_date: null,
      reopened_from_date: null,
      reopened_to_date: null,
      fixed_from_date: null,
      fixed_to_date: null,
      ignored_from_date: null,
      ignored_to_date: null,
      age_min: '',
      age_max: '',
      age_min_inclusive: 1,
      age_max_inclusive: 1,
      hosts_in: null,
      status_history_finding_id: undefined,
      SourceType: [...SourceType],
    };
    this.focus = () => this.refs.editor.focus();
    this.onChange = (editorState) => {
      // const contentState = editorState.getCurrentContent();
      this.setState({ editorState });
    };

    this.handleKeyCommand = (command) => this._handleKeyCommand(command);
    this.onTab = (e) => this._onTab(e);
    this.toggleBlockType = (type) => this._toggleBlockType(type);
    this.toggleInlineStyle = (style) => this._toggleInlineStyle(style);
  }
  orderBy(target) {
    let field = target;
    if (this.state.ordering === field) {
      field = '-' + field;
    }
    this.setState({ ordering: field });
    let self = this;
    setTimeout(function () {
      self.fetchFindings();
    }, 60);
  }
  _handleKeyCommand(command) {
    const { editorState } = this.state;
    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      this.onChange(newState);
      return true;
    }
    return false;
  }

  _onTab(e) {
    const maxDepth = 4;
    this.onChange(RichUtils.onTab(e, this.state.editorState, maxDepth));
  }

  _toggleBlockType(blockType) {
    this.onChange(RichUtils.toggleBlockType(this.state.editorState, blockType));
  }

  _toggleInlineStyle(inlineStyle) {
    this.onChange(
      RichUtils.toggleInlineStyle(this.state.editorState, inlineStyle),
    );
  }

  async updatePage() {
    let self = this;
    await self.fetchMembers(this.props.currentCompanyId);
    if (this.state.source_type.value) {
      await this.fetchHostsWithSourceType(this.state.source_type.value);
    } else {
      await self.fetchFindings();
    }
  }

  getRelevantId(source_type_value) {
    const relevantIdMap = {
      was_data: this.state.webapp,
      endpoint_data: this.state.endpoint,
      ca_data: this.state.cloudagent_id,
      'ca_data-all': this.state.cloudagent_id,
      'ca_data-workstations': this.state.cloudagent_id,
      sast2: this.state.sast_id,
    };

    return relevantIdMap[source_type_value] || null;
  }

  async fetchHostsWithSourceType(source_type_value) {
    const { baseUrl, additionalParams } =
      this.getFetchConfig(source_type_value);
    const { search, page } = this.state;

    // if (!baseUrl) return;

    this.setState({ loader: true });
    try {
      const relevantId = this.getRelevantId(source_type_value);
      if (relevantId) {
        additionalParams['relevantId'] = relevantId;
      }
      if (this.state.hosts_in?.length > 0) {
        additionalParams['hostsIn'] = this.state.hosts_in;
      }
      const res = await fetchHosts({
        baseUrl,
        search,
        page,
        limit: HOSTS_LIMIT,
        additionalParams,
      });

      if (res.results) {
        const current_host = relevantId
          ? res.results.find((datum) => Number(datum.id) === Number(relevantId))
          : null;

        this.setState({
          hostapps: res.results.length > 0 ? [].concat(res.results) : [],
          current_host: current_host,
        });

        if (this.state.hosts_in?.length > 0) {
          this.updateHostsSelection(res);
        }

        await this.fetchFindings(
          undefined,
          undefined,
          this.props.currentCompanyId,
        );
      }
    } catch (err) {
      console.error(err);
    } finally {
      this.setState({ loader: false });
    }
  }

  renderLoader() {
    if (this.state.loader === true) {
      return (
        <section className="loader-section">
          <MagicSpinner size={60} color="#0665a9" loading={this.state.loader} />
        </section>
      );
    }
  }
  toggle() {
    let modal = this.state.modal;
    this.setState({ modal: !modal });
  }
  toggleNotesModal() {
    this.setState({ notesmodal: !this.state.notesmodal });
  }
  toggleWatcherModal() {
    this.setState({ watcher_modal: !this.state.watcher_modal });
  }
  toggleIgnoreVulnModal() {
    this.setState({
      show_ignore_vuln_modal: !this.state.show_ignore_vuln_modal,
      ignored_comments: '',
    });
  }
  toggleUnignoreVulnModal() {
    this.setState({
      unignore_vuln_modal: !this.state.unignore_vuln_modal,
      ignored_comments: '',
    });
  }
  toggleAdvanceSearchModal() {
    this.setState({ advance_search_modal: !this.state.advance_search_modal });
  }
  componentDidMount() {
    let patchable = window.location.search.split('patchable=');
    if (patchable.length > 1) {
      patchable = window.location.search.split('patchable=')[1].split('&')[0];
      this.setState({
        selectedCategoryOption: {
          value: '&knowledge_base__patchable=1',
          label: 'Patchable',
        },
      });
    }
    let obsolete = window.location.search.split('obsolete=');
    if (obsolete.length > 1) {
      obsolete = window.location.search.split('obsolete=')[1].split('&')[0];
      this.setState({
        selectedCategoryOption: {
          value: '&title__icontains=Obsolete',
          label: 'Obsolete',
        },
      });
    }
    let qid = window.location.search.split('qid=');
    if (qid.length > 1) {
      qid = window.location.search.split('qid=')[1].split('&')[0];
      this.setState({ qid: qid });
    }
    let rule_id = window.location.search.split('rule_id=');
    if (rule_id.length > 1) {
      rule_id = window.location.search.split('rule_id=')[1].split('&')[0];
      this.setState({ rule_id: rule_id });
    }
    let issue_type = window.location.search.split('issue_type=');
    if (issue_type.length > 1) {
      issue_type = window.location.search.split('issue_type=')[1].split('&')[0];
      if (issue_type === 'All') {
        issue_type = '';
        this.setState({
          selectedIssueTypeOption: { value: '', label: 'All' },
          issue_type: '',
        });
      } else if (issue_type === 'BUG') {
        this.setState({
          selectedIssueTypeOption: { value: 'BUG', label: 'Bugs' },
          issue_type: 'BUG',
        });
      } else {
        this.setState({
          selectedIssueTypeOption: {
            value: 'VULNERABILITY',
            label: 'Vulnerability',
          },
          issue_type: 'VULNERABILITY',
        });
      }
    }

    let webapp = window.location.search.split('webapp=');
    if (webapp.length > 1) {
      webapp = webapp[1].split('&')[0];
      this.setState({ webapp: webapp });
    }
    let bpr = window.location.search.split('bpr=');
    if (bpr.length > 1) {
      bpr = bpr[1].split('&')[0];
      this.setState({ bpr: bpr });
    }
    let endpoint = window.location.search.split('endpoint_id=');
    if (endpoint.length > 1) {
      endpoint = endpoint[1].split('&')[0];
      this.setState({ endpoint: endpoint });
    }
    let cloudagent_id = window.location.search.split('cloudagent_id=');
    if (cloudagent_id.length > 1) {
      cloudagent_id = cloudagent_id[1].split('&')[0];
      this.setState({ cloudagent_id: cloudagent_id });
    }
    let sast_id = window.location.search.split('sast_id=');
    if (sast_id.length > 1) {
      sast_id = sast_id[1].split('&')[0];
      this.setState({ sast_id: sast_id });
    }
    let bpr_id = window.location.search.split('bpr_id=');
    if (bpr_id.length > 1) {
      bpr_id = bpr_id[1].split('&')[0];
      this.setState({ bpr_id: bpr_id });
    }
    let search = window.location.search.split('search=');
    if (search.length > 1) {
      search = window.location.search.split('search=')[1].split('&')[0];
      let decodedSearch = decodeURIComponent(search);
      this.setState({ company_search_data: decodedSearch });
    }
    let filter_severity = window.location.search.split('filter_severity=');
    if (filter_severity.length > 1) {
      filter_severity = window.location.search
        .split('filter_severity=')[1]
        .split('&')[0];
      this.setState({ filter_severity: filter_severity });
    } else if (window.location.search.split('severity=').length > 1) {
      let severity = window.location.search.split('severity=')[1].split('&')[0];

      let selectedSeverityOption = {
        value: severity,
        label: SeverityList[severity],
      };
      this.setState({ selectedSeverityOption: selectedSeverityOption });
    }

    if (window.location.search.split('source_type=').length > 1) {
      let source_type = window.location.search
        .split('source_type=')[1]
        .split('&')[0];

      if (source_type === 'endpoint_data_external') {
        this.setState({ scanner_type: 'External' });
      } else if (source_type === 'endpoint_data_internal') {
        this.setState({ scanner_type: 'Internal' });
      } else if (source_type === 'endpoint_data_ec2') {
        this.setState({ scanner_type: 'EC2' });
      }
      source_type = {
        value: source_type,
        label: SourceType.find((x) => x.value === source_type)?.label,
      };
      this.setState({ source_type: source_type });
    }
    let type = window.location.search
      .replace('source_type=', 'dummy=')
      .replace('issue_type=', 'dummy=')
      .split('type=');
    if (type.length > 1) {
      type = type[1].split('&')[0];

      this.setState({
        statuses: [
          {
            value: type,
            label: StatusOptions.find((x) => x.value === type)?.label,
          },
        ],
      });
    }

    // new date filters
    const params = getQueryParams();
    const {
      created_from_date,
      created_to_date,
      reopened_from_date,
      reopened_to_date,
      fixed_from_date,
      fixed_to_date,
      ignored_from_date,
      ignored_to_date,
      hosts_in,
      severity_in,
      age_min,
      age_max,
    } = params;

    if (created_from_date) {
      this.setState({ created_from_date: parseInt(created_from_date) });
    }
    if (created_to_date) {
      this.setState({ created_to_date: parseInt(created_to_date) });
    }

    if (reopened_from_date) {
      this.setState({ reopened_from_date: parseInt(reopened_from_date) });
    }
    if (reopened_to_date) {
      this.setState({ reopened_to_date: parseInt(reopened_to_date) });
    }

    if (fixed_from_date) {
      this.setState({ fixed_from_date: parseInt(fixed_from_date) });
    }
    if (fixed_to_date) {
      this.setState({ fixed_to_date: parseInt(fixed_to_date) });
    }

    if (ignored_from_date) {
      this.setState({ ignored_from_date: parseInt(ignored_from_date) });
    }

    if (ignored_to_date) {
      this.setState({ ignored_to_date: parseInt(ignored_to_date) });
    }

    if (age_min) {
      this.setState({ age_min: parseInt(age_min), age_min_inclusive: 0 });
    }

    if (age_max) {
      this.setState({ age_max: parseInt(age_max), age_max_inclusive: 1 });
    }

    //  if some selected hosts filters need to be applied
    if (hosts_in?.length > 0) {
      const hosts_in_array = hosts_in.split(',');
      // label need to be updated after the component is mounted
      this.setState({ hosts_in: hosts_in_array });
    }
    //  if some selected severity filters need to be applied
    if (severity_in) {
      const severity_in_array = severity_in.split(',');
      // label need to be updated after the component is mounted
      this.setState({
        selectedSeverityOption: severity_in_array.map((severity) => {
          return { value: severity, label: SeverityList[severity] };
        }),
      });
    }
    this.updatePage();
    localStorage.setItem('last_path', window.location.pathname);
  }
  componentDidUpdate(prevProps, prevState) {
    // Check if the specific prop has been updated
    if (this.props.currentCompanyId !== prevProps.currentCompanyId) {
      //! Need to reset the drilldown state of the host type to clear the selected host on company change
      this.setState({
        webapp: null,
        endpoint: null,
        cloudagent_id: null,
        sast_id: null,
      });
      this.updatePage();
    }
  }

  parseCategoryOptionsParams(params, selectedCategoryOptionValue) {
    const queryStrings = selectedCategoryOptionValue.split('&');

    queryStrings.forEach((queryString) => {
      const [key, value] = queryString.split('=');
      if (key && value) {
        params[key] = decodeURIComponent(value);
      }
    });

    return params;
  }

  getFetchFindingsUrlParams(companyId, currentPage) {
    if (companyId === undefined) {
      companyId = this.props.currentCompanyId;
    }
    if (companyId === undefined || companyId === -1) return '';
    // const advance_search_filters_count = this.getAdvancedFiltersCount();
    // this.setState({ loader: true , advance_search_modal:false,advance_search_filters_count:advance_search_filters_count})

    const params = {
      company: companyId,
      search: this.state.company_search_data,
      limit: parseInt(this.state.pageSize),
      offset: parseInt(
        this.state.pageSize * (currentPage ? parseInt(currentPage) : 0),
      ),
      ordering: this.state.ordering,
    };

    if (this.state.filter_severity && this.state.filter_severity !== '') {
      params['severity__in'] = '5,4';
    } else {
      params['severity__in'] = this.getSelectedSeverityOptions();
    }
    if (this.state.patchable && this.state.patchable !== '') {
      params['knowledge_base__patchable'] = 1;
    }

    // url += this.state.selectedCategoryOption.value
    this.parseCategoryOptionsParams(
      params,
      this.state.selectedCategoryOption.value,
    );

    let statuses = this.state.statuses;
    if (statuses?.length > 0) {
      let status_values = statuses.map((status) => status.value.toUpperCase());
      let selected_statuses = [];

      if (status_values.includes('ALL')) {
        selected_statuses.push('NEW', 'ACTIVE', 'REOPENED', 'FIXED', 'IGNORED');
      } else if (status_values.includes('OPEN')) {
        selected_statuses.push('NEW', 'ACTIVE', 'REOPENED');
      } else if (status_values.includes('CLOSED')) {
        selected_statuses.push('FIXED', 'IGNORED');
      }

      status_values.forEach((value) => {
        if (
          value !== 'OPEN' &&
          value !== 'CLOSED' &&
          !selected_statuses.includes(value)
        ) {
          selected_statuses.push(value);
        }
      });

      params['status__in'] = selected_statuses;
    }

    let source_type = '';
    if (this.state.source_type.value !== '') {
      if (
        this.state.source_type.value === 'endpoint_data_external' ||
        this.state.source_type.value === 'endpoint_data_internal' ||
        this.state.source_type.value === 'endpoint_data_ec2' ||
        this.state.source_type.value === 'endpoint_data'
      ) {
        source_type = 'endpoint_data';
        // url += '&source_type=' + source_type
        params['source_type'] = source_type;
      } else {
        // url += '&source_type=' + this.state.source_type.value
        params['source_type'] = this.state.source_type.value;
      }
    } else {
      // url += '&source_type='
      params['source_type'] = '';
    }

    if (this.state.issue_type !== '')
      params['issue_type'] = this.state.issue_type;
    if (this.state.source_type.value === 'was_data') {
      const selectedHostIds = this.getSelectedHostIds();
      if (selectedHostIds?.length > 0) params['webapp'] = selectedHostIds;
    } else if (
      this.state.source_type.value === 'ca_data-all' ||
      this.state.source_type.value === 'ca_data' ||
      this.state.source_type.value === 'ca_data-workstations'
    ) {
      const selectedHostIds = this.getSelectedHostIds();
      if (selectedHostIds?.length > 0) params['cloud_agent'] = selectedHostIds;
    } else if (source_type === 'endpoint_data') {
      const selectedHostIds = this.getSelectedHostIds();
      if (selectedHostIds?.length > 0) params['endpoint'] = selectedHostIds; // url += `&endpoint=${selectedHostIds}`
      if (this.state.scanner_type)
        params['scanner_type'] = this.state.scanner_type; // url += '&scanner_type=' + this.state.scanner_type;
    } else if (this.state.source_type.value === 'sast') {
      const selectedHostIds = this.getSelectedHostIds();
      if (selectedHostIds?.length > 0)
        params['github_hook_id'] = selectedHostIds; // url += `&github_hook_id=${selectedHostIds}`
    } else if (this.state.source_type.value === 'sast2') {
      const selectedHostIds = this.getSelectedHostIds();
      if (selectedHostIds?.length > 0)
        params['repository_id'] = selectedHostIds; // url += `&github_hook_id=${selectedHostIds}`
    } else if (this.state.source_type.value === 'bpr') {
      const selectedHostIds = this.getSelectedHostIds();
      if (selectedHostIds?.length > 0) params['bpr'] = selectedHostIds; // url += `&bpr=${selectedHostIds}`
    }

    if (this.state.last_detected_from_date) {
      let last_detected_from_date = moment(
        this.state.last_detected_from_date,
      ).format('X');
      params['last_detected_from_date'] = last_detected_from_date;
    }
    if (this.state.last_detected_to_date) {
      let last_detected_to_date = moment(
        this.state.last_detected_to_date,
      ).format('X');
      params['last_detected_to_date'] = last_detected_to_date;
    }
    if (this.state.last_tested_from_date) {
      let last_tested_from_date = moment(
        this.state.last_tested_from_date,
      ).format('X');
      params['last_tested_from_date'] = last_tested_from_date;
    }
    if (this.state.last_tested_to_date) {
      let last_tested_to_date = moment(this.state.last_tested_to_date).format(
        'X',
      );
      params['last_tested_to_date'] = last_tested_to_date;
    }
    if (this.state.due_from_date) {
      let due_from_date = moment(this.state.due_from_date).format('X');
      params['due_from_date'] = due_from_date;
    }
    if (this.state.due_to_date) {
      let due_to_date = moment(this.state.due_to_date).format('X');
      params['due_to_date'] = due_to_date;
    }
    if (this.state.created_from_date) {
      let created_from_date = moment(this.state.created_from_date).format('X');
      params['created_from_date'] = created_from_date;
    }
    if (this.state.created_to_date) {
      let created_to_date = moment(this.state.created_to_date).format('X');
      params['created_to_date'] = created_to_date;
    }
    if (this.state.reopened_from_date) {
      let reopened_from_date = moment(this.state.reopened_from_date).format(
        'X',
      );
      params['reopened_from_date'] = reopened_from_date;
    }
    if (this.state.reopened_to_date) {
      let reopened_to_date = moment(this.state.reopened_to_date).format('X');
      params['reopened_to_date'] = reopened_to_date;
    }
    if (this.state.fixed_from_date) {
      let fixed_from_date = moment(this.state.fixed_from_date).format('X');
      params['fixed_from_date'] = fixed_from_date;
    }
    if (this.state.fixed_to_date) {
      let fixed_to_date = moment(this.state.fixed_to_date).format('X');
      params['fixed_to_date'] = fixed_to_date;
    }
    if (this.state.ignored_from_date) {
      let ignored_from_date = moment(this.state.ignored_from_date).format('X');
      params['ignored_from_date'] = ignored_from_date;
    }
    if (this.state.ignored_to_date) {
      let ignored_to_date = moment(this.state.ignored_to_date).format('X');
      params['ignored_to_date'] = ignored_to_date;
    }
    if (this.state.qid) {
      params['qid'] = this.state.qid; //            url += '&qid=' + this.state.qid
    }
    if (this.state.rule_id) {
      params['rule_id'] = this.state.rule_id;
    }

    if (this.state.age_min !== '') {
      params['age_min'] = this.state.age_min;
      if (this.state.age_min_inclusive) {
        params['age_min_inclusive'] = this.state.age_min_inclusive;
      }
    }

    if (this.state.age_max !== '') {
      params['age_max'] = this.state.age_max;
      if (this.state.age_max_inclusive) {
        params['age_max_inclusive'] = this.state.age_max_inclusive;
      }
    }

    return params;
  }

  getAdvancedFiltersCount() {
    let advance_search_filters_count = 0;
    if (
      this.state.last_detected_from_date ||
      this.state.last_detected_to_date
    ) {
      advance_search_filters_count += 1;
    }
    if (this.state.last_tested_from_date || this.state.last_tested_to_date) {
      advance_search_filters_count += 1;
    }
    if (this.state.due_from_date || this.state.due_to_date) {
      advance_search_filters_count += 1;
    }
    if (this.state.created_from_date || this.state.created_to_date) {
      advance_search_filters_count += 1;
    }
    if (this.state.reopened_from_date || this.state.reopened_to_date) {
      advance_search_filters_count += 1;
    }
    if (this.state.fixed_from_date || this.state.fixed_to_date) {
      advance_search_filters_count += 1;
    }
    if (this.state.ignored_from_date || this.state.ignored_to_date) {
      advance_search_filters_count += 1;
    }
    if (this.state.qid) {
      advance_search_filters_count += 1;
    }
    if (this.state.rule_id) {
      advance_search_filters_count += 1;
    }

    if (this.state.age_min !== '') {
      advance_search_filters_count += 1;
    }

    if (this.state.age_max !== '') {
      advance_search_filters_count += 1;
    }
    return advance_search_filters_count;
  }

  appendParamsToUrl(url, params) {
    const urlObj = new URL(url, window.location.href);
    const existingParams = new URLSearchParams(urlObj.search);
    const newParams = new URLSearchParams();

    for (const [key, value] of Object.entries(params)) {
      if (!existingParams.has(key)) {
        newParams.set(key, value);
      }
    }

    const queryString = newParams.toString();
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}${queryString ? queryString : ''}`;
  }

  async fetchFindings(currentUrl, currentPage, company_id) {
    const advance_search_filters_count = this.getAdvancedFiltersCount();
    this.setState({
      loader: true,
      advance_search_modal: false,
      advance_search_filters_count: advance_search_filters_count,
    });

    if (company_id === undefined) {
      company_id = this.props.currentCompanyId;
    }

    if (currentPage !== undefined) {
      this.setState({ currentPage: currentPage });
    } else {
      this.setState({ currentPage: 0 });
    }

    let url = '/findings/';
    if (currentUrl) {
      url = currentUrl;
    }
    url = this.appendParamsToUrl(
      url,
      this.getFetchFindingsUrlParams(company_id, currentPage),
    );

    await callApi(url, 'GET', {})
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          if (res.data.results) {
            this.setState({
              loader: false,
              reports: res.data.results,
              count: res.data.count,
              nextUrl: res.data.next
                ? process.env.REACT_APP_SERVER_PATH +
                  '/findings/?' +
                  res.data.next.split('?')[1]
                : null,
              previousUrl: res.data.previous
                ? process.env.REACT_APP_SERVER_PATH +
                  '/findings/?' +
                  res.data.previous.split('?')[1]
                : null,
            });
            if (document.getElementsByClassName('main-panel').length > 0)
              document.getElementsByClassName('main-panel')[0].scrollTop = 0;
          } else {
            this.setState({ reports: [], count: 0 });
          }

          this.setState({ modal: false });
        } else if (res.status === 422) {
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.setState({ loader: false });
      });
  }

  getSelectedHostIds() {
    if (
      Array.isArray(this.state.current_host) &&
      this.state.current_host.length > 0 &&
      this.state.current_host[0].id
    ) {
      return this.state.current_host.map((x) => x.id);
    } else if (this.state.current_host?.id) {
      return [this.state.current_host.id];
    }

    return [];
  }

  getSelectedSeverityOptions() {
    if (
      Array.isArray(this.state.selectedSeverityOption) &&
      this.state.selectedSeverityOption.length > 0 &&
      this.state.selectedSeverityOption[0].value
    ) {
      return this.state.selectedSeverityOption.map((x) => x.value);
    } else if (this.state.selectedSeverityOption?.value)
      return [this.state.selectedSeverityOption.value];
    return [];
  }

  updateHostsSelection(res) {
    let self = this;
    let selectedHosts = [];
    const results = res.results || [];
    results.map((datum) => {
      if (self.state.hosts_in.includes(datum.id.toString())) {
        selectedHosts.push(datum);
      }
    });

    self.setState({ current_host: selectedHosts, hosts_in: null });
  }

  async fetchFindingDetail(id) {
    this.setState({ loader: true });
    let url = '/findings/' + id + '/';

    callApi(url, 'GET', {})
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            this.setState({
              currentReport: res.data,
              loader: false,
              modal: true,
              notesmodal: false,
            });
          }
        } else if (res.status === 422) {
        } else if (res.status === 401 || res.status === 400) {
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.setState({ loader: false });
      });
  }
  removeObjectWithId(arr, id) {
    const objWithIdIndex = arr.findIndex((obj) => obj.users_id === id);
    if (objWithIdIndex > -1) {
      arr.splice(objWithIdIndex, 1);
    }
    return arr;
  }

  async fetchWatchers(id) {
    this.setState({ loader: true });
    let self = this;
    let watchers_options = [...this.state.members];
    let url = '/assignee_maps/watchers/?finding_id=' + id;
    callApi(url, 'GET', {})
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            res.data.results.forEach(function (r) {
              watchers_options = self.removeObjectWithId(
                watchers_options,
                r.user,
              );
            });
            this.setState({
              // notes: res.data,
              watchers: res.data.results,
              watchers_options: watchers_options,
              loader: false,
              watcher_modal: true,
              current_finding_id: id,
            });
          }
        } else if (res.status === 422) {
        }
      })
      .finally(() => {
        this.setState({ loader: false });
      });
  }

  async onIgnoreSuccess(ignore) {
    let message = 'The vulnerability has been successfully ignored.';
    if (ignore === false) {
      message = 'The vulnerability has been successfully unignored.';
    }
    this.setState({
      show_ignore_vuln_modal: false,
      unignore_vuln_modal: false,
      ignored_comments: '',
      loader: false,
      openModal: true,
      is_success: true,
      modalTitle: 'Success',
      modalDetail: 'The vulnerability has been successfully ignored.',
    });
    toast.info('Success! ' + message, {
      position: 'bottom-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    let sourceType = this.state.source_type.value;
    if (
      sourceType === 'endpoint_data_external' ||
      sourceType === 'endpoint_data_internal' ||
      sourceType === 'endpoint_data_ec2' ||
      sourceType === 'endpoint_data' ||
      sourceType === ''
    ) {
      localStorage.setItem('ep_refresh', Math.random().toString());
    } else if (sourceType === 'was_data' || sourceType === '') {
      localStorage.setItem('wa_refresh', Math.random().toString());
    } else if (
      sourceType === 'ca_data' ||
      sourceType === 'ca_data-workstations' ||
      sourceType === 'ca_data-all' ||
      sourceType === ''
    ) {
      localStorage.setItem('ca_refresh', Math.random().toString());
    } else if (sourceType === 'sast' || sourceType === 'sast2') {
      localStorage.setItem('sast_refresh', Math.random().toString());
    }
    let self = this;
    setTimeout(function () {
      self.fetchFindings();
    }, 100);
  }

  async onIgnoreFailure(message) {
    this.setState({
      loader: false,
      openModal: true,
      is_success: false,
      modalTitle: 'Error',
      modalDetail: message,
    });
    toast.error('Error! ' + message, {
      position: 'bottom-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }

  openIgnoreVulnModal(ignoreFindingData) {
    this.setState({
      show_ignore_vuln_modal: true,
      ignore_finding_data: ignoreFindingData,
    });
  }
  openUnignoreVulnModal(unignoreFindingData) {
    this.setState({
      unignore_vuln_modal: true,
      unignore_finding_data: unignoreFindingData,
    });
  }
  openAdvanceSearchModal() {
    this.setState({
      advance_search_modal: true,
    });
  }
  async fetchFindingNotes(id) {
    this.setState({ loader: true });
    let url = '/notes/?finding_id=' + id;
    callApi(url, 'GET', {})
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            this.setState({
              notes: res.data,
              loader: false,
              notesmodal: true,
              current_finding_id: id,
            });
          }
        } else if (res.status === 422) {
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.setState({ loader: false });
      });
  }
  async saveNote() {
    this.setState({ loader: true });
    let url = '/notes/?finding_id=' + this.state.current_finding_id,
      data = {
        data: this.renderContentAsRawJs(),
      };

    if (data['data'].trim().length === 0) {
      toast.error('Error! ' + 'Please enter data in the Notes field.', {
        position: 'bottom-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    callApi(url, 'POST', {}, data)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            this.setState({
              loader: false,
              notesmodal: true,
            });
            let notes = this.state.notes;
            notes.results.unshift(res.data);
            this.setState({
              notes: notes,
              editorState: EditorState.createEmpty(),
              openModal: true,
              is_success: true,
              modalTitle: 'Comment added',
              modalDetail: 'Your comment has been successfully posted.',
            });
          }
        } else if (res.status === 422) {
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.setState({ loader: false });
      });
  }
  renderNextUrl() {
    if (this.state.nextUrl !== null) {
      return (
        <PaginationItem>
          <PaginationLink
            next
            onClick={() =>
              this.fetchFindings(this.state.nextUrl, this.state.currentPage + 1)
            }
          />
        </PaginationItem>
      );
    } else {
      return <></>;
    }
  }
  renderPreviousUrl() {
    if (this.state.previousUrl !== null) {
      return (
        <PaginationItem>
          <PaginationLink
            previous
            onClick={() =>
              this.fetchFindings(
                this.state.previousUrl,
                this.state.currentPage - 1,
              )
            }
          />
        </PaginationItem>
      );
    } else {
      return <></>;
    }
  }
  renderPages() {
    let pages = [];
    let pageCount = Math.ceil(this.state.count / this.state.pageSize),
      currentPage = this.state.currentPage;
    let leftPages = pageCount > 10 ? (currentPage > 8 ? 6 : 10) : pageCount;
    let midPages = currentPage > 8 ? 3 : 0;
    let rightPages = pageCount - leftPages;
    for (let index = 0; index < leftPages; index++) {
      pages.push(
        <PaginationItem
          key={index}
          className={this.state.currentPage === index ? 'active' : ''}
        >
          <PaginationLink onClick={() => this.fetchFindings(undefined, index)}>
            {index + 1}
          </PaginationLink>
        </PaginationItem>,
      );
    }
    if (midPages > 1) {
      pages.push(<PaginationItem className="more-pages">...</PaginationItem>);
    }
    for (let index = 0; index < midPages; index++) {
      let pageIndex = index - 1 + currentPage;
      if (pageIndex < pageCount - 1) {
        pages.push(
          <PaginationItem
            className={this.state.currentPage === pageIndex ? 'active' : ''}
          >
            <PaginationLink
              onClick={() => this.fetchFindings(undefined, pageIndex)}
            >
              {pageIndex + 1}
            </PaginationLink>
          </PaginationItem>,
        );
      }
    }
    if (rightPages > 1 && pageCount - 3 > currentPage) {
      pages.push(
        <PaginationItem key={'right' + '-0'} className="more-pages">
          ...
        </PaginationItem>,
      );
    }
    if (rightPages >= 1) {
      pages.push(
        <PaginationItem
          key={'right' + '-1'}
          className={this.state.currentPage === pageCount - 1 ? 'active' : ''}
        >
          <PaginationLink
            onClick={() => this.fetchFindings(undefined, pageCount - 1)}
          >
            {pageCount}
          </PaginationLink>
        </PaginationItem>,
      );
    }
    // }
    return (
      <>
        {pages.map((item, index) => {
          return item;
        })}
      </>
    );
  }
  renderPagination() {
    let pageCount = Number(this.state.count / this.state.pageSize);
    if (pageCount > 1) {
      return (
        <Row>
          <Col sm="12" md="9" lg="10">
            <Pagination aria-label="Page navigation example">
              {this.renderPreviousUrl()}
              {this.renderPages()}
              {this.renderNextUrl()}
            </Pagination>
          </Col>
          <Col sm="12" md="3" lg="2">
            <Select
              className="custom-360-dropdown"
              value={{
                label: this.state.pageSize.toString(),
                value: this.state.pageSize.toString(),
              }}
              onChange={(e) => {
                this.setState({ pageSize: parseInt(e.value) });
                let self = this;
                setTimeout(function () {
                  self.fetchFindings();
                }, 100);
              }}
              styles={slimColourStyles}
              options={PAGE_SIZES}
            />
          </Col>
        </Row>
      );
    } else if (this.state.count > 25) {
      return (
        <Row>
          <Col sm="12" md="9" lg="10"></Col>
          <Col sm="12" md="3" lg="2">
            <Select
              className="custom-360-dropdown"
              value={{
                label: this.state.pageSize.toString(),
                value: this.state.pageSize.toString(),
              }}
              onChange={(e) => {
                this.setState({ pageSize: parseInt(e.value) });
                let self = this;
                setTimeout(function () {
                  self.fetchFindings();
                }, 100);
              }}
              styles={slimColourStyles}
              options={PAGE_SIZES}
            />
          </Col>
        </Row>
      );
    }
  }
  async fetchMembers(company_id) {
    if (this.props.currentCompanyId) {
      this.setState({ loader: true });
      // let company_id = this.state.selectedCompanyOption.id
      let url = '/profiles/colleague/?search=&is_active=True';
      url += '&company=' + company_id;

      await callApi(url, 'GET', {})
        .then((res) => {
          if (res.status === 201 || res.status === 200) {
            if (res.data.results) {
              let members = res.data.results;
              this.setState({
                members: members,
                // @salaarkhan-dev
                // TODO: why we updating the count state here?
                count: res.data.count,
                nextUrl: res.data.next
                  ? process.env.REACT_APP_SERVER_PATH +
                    '/profiles/colleague/?' +
                    res.data.next.split('?')[1]
                  : null,
                previousUrl: res.data.previous
                  ? process.env.REACT_APP_SERVER_PATH +
                    '/profiles/colleague/?' +
                    res.data.previous.split('?')[1]
                  : null,
              });
              document.getElementsByClassName('main-panel')[0].scrollTop = 0;
            } else {
              this.setState({ members: [], count: 0 });
            }
          } else if (res.status === 422) {
          }
        })
        .catch((err) => {})
        .finally(() => {
          this.setState({ loader: false });
        });
    }
  }
  async unassignFinding(vuln) {
    this.setState({ loader: true });
    let url = process.env.REACT_APP_SERVER_PATH + '/assignee_maps/',
      data = {
        finding: vuln.id,
        user: '-1',
      };
    callApi(url, 'POST', {}, data)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            const updatedReports = this.state.reports.map((report) => {
              if (report.id === vuln.id) {
                // Update the specific report with the new data
                return {
                  ...report,
                  assigned_member_label: '',
                  assigned_member_id: '',
                  assigned_member_profile: '',
                };
              }
              return report;
            });

            this.setState({
              loader: false,
              reports: updatedReports,
              openModal: true,
              is_success: true,
              modalTitle: 'Success',
              modalDetail:
                'The vulnerability has been successfully unassigned.',
            });
          }
        } else if (res.status === 422) {
          // console.log('Error')
          this.setState({
            loader: false,
          });
          this.setState({
            openModal: true,
            is_success: false,
            modalTitle: 'Error',
            modalDetail: res.data.detail,
          });
          toast.error('Error! ' + (res && res.data ? res.data.detail : ''), {
            position: 'bottom-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else if (res.status === 401 || res.status === 400) {
        }
      })
      .catch((err) => {
        console.error('Error', err);
        let res = err.response;
        if (err.response.status === 422) {
          this.setState({
            loader: false,
          });
          this.setState({
            openModal: true,
            is_success: false,
            modalTitle: 'Error',
            modalDetail: res.data.detail,
          });
          toast.error('Error! ' + (res && res.data ? res.data.detail : ''), {
            position: 'bottom-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      })
      .finally(() => {
        this.setState({ loader: false });
      });
  }
  async assignMemberToVuln(
    vuln_id,
    user_id,
    assigned_member_label,
    assigned_member_profile,
  ) {
    this.setState({ loader: true });
    let url = '/assignee_maps/';
    const data = {
      finding: vuln_id,
      user: user_id,
    };
    callApi(url, 'POST', {}, data)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            const updatedReports = this.state.reports.map((report) => {
              if (report.id === vuln_id) {
                // Update the specific report with the new data
                return {
                  ...report,
                  assigned_member_label: assigned_member_label,
                  assigned_member_id: user_id,
                  assigned_member_profile: assigned_member_profile,
                };
              }
              return report;
            });
            this.setState({
              reports: updatedReports,
              loader: false,
              openModal: true,
              is_success: true,
              modalTitle: 'Success',
              modalDetail:
                'The vulnerability has been successfully assigned to the member.',
            });
          }
        } else if (res.status === 422) {
          console.error('Error');
          this.setState({
            loader: false,
          });
          this.setState({
            openModal: true,
            is_success: false,
            modalTitle: 'Error',
            modalDetail: res.data.detail,
          });
          toast.error('Error! ' + (res && res.data ? res.data.detail : ''), {
            position: 'bottom-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      })
      .catch((err) => {
        console.error('Error', err);
        let res = err.response;
        if (err.response.status === 422) {
          this.setState({
            loader: false,
          });
          this.setState({
            openModal: true,
            is_success: false,
            modalTitle: 'Error',
            modalDetail: res.data.detail,
          });
          toast.error('Error! ' + (res && res.data ? res.data.detail : ''), {
            position: 'bottom-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });
  }
  createNameInitials(data) {
    let parsed_data = data.name_initails;
    let names = data.email.split('.');
    if (parsed_data.length === 0) {
      parsed_data = data.email[0];
      if (names.length === 0) {
        names = data.email.split('-');
      }
      if (names.length === 0) {
        names = data.email.split('_');
      }
      if (names.length === 0) {
        names = data.email.split('@');
      }
      if (names.length > 0) parsed_data += names[1][0];
    }
    return parsed_data.toUpperCase();
  }
  renderAssignSelect(data, idx) {
    let assigned_member = {
      label: data.assigned_member_label,
      value: data.assigned_member_profile,
    };
    let assignee = this.state.members.find(
      (member) => member.value === data.assigned_member_profile,
    );
    return (
      <>
        <div
          title={
            this.isIgnoredStatusSelected()
              ? 'Ignored vulnerability cannot be assigned to a member'
              : ''
          }
        >
          <Select
            id={`assignee-${idx}`}
            className="custom-360-dropdown profile-pic-dropdown"
            onChange={(e) => {
              let assigned_member_label = e.name_initails;
              let assigned_member_id = e.users_id;
              let assigned_member_profile = e.value;
              this.assignMemberToVuln(
                data.id,
                assigned_member_id,
                assigned_member_label,
                assigned_member_profile,
              );
            }}
            isDisabled={this.isIgnoredStatusSelected()}
            value={assigned_member}
            menuPortalTarget={document.body}
            styles={memberStyles}
            options={this.state.members}
          />
          {assignee && (
            <UncontrolledTooltip placement="top" target={`assignee-${idx}`}>
              <p style={{ color: 'black' }}>
                {assignee.name}
                <br /> {assignee.email}
              </p>
            </UncontrolledTooltip>
          )}
        </div>
      </>
    );
  }

  isIgnoredStatusSelected() {
    return this.state.statuses?.includes('ignored');
  }

  renderButton(data) {
    let title = 'Ignore';
    if (data.is_ignored === true) {
      title = '';
    }

    const showIgnoreButton =
      data.status !== 'FIXED' &&
      (data.source_type === 'was_data' ||
        data.source_type === 'sast' ||
        data.source_type === 'endpoint_data' ||
        ((data.source_type === 'ca_data' ||
          data.source_type === 'ca_data-workstations' ||
          data.source_type === 'ca_data-all') &&
          data.cloud_agent_is_tagged));
    const showUnignoreButton =
      data.source_type === 'was_data' ||
      data.source_type === 'sast' ||
      data.source_type === 'endpoint_data' ||
      ((data.source_type === 'ca_data' ||
        data.source_type === 'ca_data-workstations' ||
        data.source_type === 'ca_data-all') &&
        data.cloud_agent_is_tagged);
    let tooltip = '';
    if (data.source_type.includes('ca_data') && !data.cloud_agent_is_tagged) {
      tooltip = "This Cloudagent isn't Tagged";
    } else if (!data.is_ignored && data.status === 'FIXED') {
      tooltip = "Ignore isn't available for FIXED vulnerability";
    } else if (data.is_ignored) {
      tooltip = 'Unignore';
    } else {
      tooltip = 'Ignore';
    }
    return (
      <Row>
        <Col sm="6">
          <Button
            color="primary"
            title={'Show details'}
            outline
            size="sm"
            onClick={() => this.fetchFindingDetail.bind(this)(data.id)}
          >
            <i className="fa fa-eye"></i>
          </Button>
        </Col>
        <Col sm="6">
          <Button
            color="primary"
            title={'Add notes'}
            outline
            size="sm"
            onClick={() => this.fetchFindingNotes.bind(this)(data.id)}
          >
            <i className="tim-icons icon-chat-33"></i>
          </Button>
        </Col>
        <Col sm="6">
          <div
            title={
              data.is_ignored
                ? 'Watchers cannot be added for ignored vulnerabilities'
                : ''
            }
          >
            <Button
              color="primary"
              title={'Add watchers'}
              outline
              size="sm"
              disabled={data.is_ignored}
              onClick={() => this.fetchWatchers.bind(this)(data.id)}
            >
              <i className="fa fa-users" aria-hidden="true"></i>
            </Button>
          </div>
        </Col>
        <Col sm="6">
          {data.source_type !== 'ca_data' && (
            <div title={tooltip}>
              {data.is_ignored ? (
                <Button
                  color="primary"
                  outline
                  size="sm"
                  disabled={!showUnignoreButton}
                  onClick={() => this.openUnignoreVulnModal.bind(this)(data)}
                >
                  <i
                    className="fa-regular fa-circle-check"
                    aria-hidden="true"
                    style={{ color: 'green' }}
                  ></i>
                </Button>
              ) : (
                <Button
                  color="primary"
                  outline
                  size="sm"
                  disabled={!showIgnoreButton}
                  onClick={() => this.openIgnoreVulnModal.bind(this)(data)}
                >
                  <i
                    className="fa fa-ban"
                    aria-hidden="true"
                    style={{ color: 'red' }}
                  ></i>
                </Button>
              )}
            </div>
          )}
        </Col>
      </Row>
    );
  }
  renderURLData(data) {
    if (data.length > 40) {
      return (
        <a href={data} target="blank">
          {data.substr(0, 40)}...
        </a>
      );
    } else {
      return (
        <a href={data} target="blank">
          {data}
        </a>
      );
    }
  }

  renderSastHostName(data) {
    //  if new sast

    if (data['host_name'] && data['host_name']['repository']) {
      return (
        <>
          <strong>{data['host_name']['repository']}</strong>/
          {data['host_name']['branch']}
        </>
      );
    } else {
      return data['host_name'] || '';
    }
  }

  renderReportList() {
    let reports = this.state.reports;
    return (
      <>
        {reports.map((data, idx) => {
          let vuln = data['issue_type'];
          if (vuln.length > 2) {
            vuln =
              vuln.substr(0, 1).toUpperCase() + vuln.substr(1).toLowerCase();
          }
          let due_date = data.due_date
            ? moment.parseZone(data.due_date).toDate()
            : '';
          let is_ignored = data.is_ignored;
          let status = data.status;
          let portString = undefined;
          if (data['port']) {
            portString = `port ${data['port']}/${data['protocol']}`;
            if (data['ssl'] !== false) {
              portString = portString + ' over SSL';
            }
          }

          return (
            <tr key={idx}>
              <td>
                {data['finding_id'] && data['finding_id'] !== ''
                  ? data['finding_id']
                  : data['host_instance_vuln_id'] &&
                    data['host_instance_vuln_id'] !== ''
                  ? data['host_instance_vuln_id']
                  : data['id']}
              </td>
              <td>
                {data['source_type'] === 'was_data'
                  ? 'Web App'
                  : data['source_type'] === 'endpoint_data'
                  ? 'Endpoint'
                  : data['source_type'] === 'sast'
                  ? 'SAST'
                  : data['source_type'] === 'bpr'
                  ? 'Cloud BPA'
                  : 'Cloud Agent'}
              </td>
              <td>
                {data['name']}
                {data['port'] && (
                  <span style={{ display: 'block', cursor: 'pointer' }}>
                    {' '}
                    <i>({portString})</i>
                  </span>
                )}
              </td>
              <td>
                <span>
                  {data['web_app'] !== undefined &&
                  data['web_app'] !== '' &&
                  data['web_app'] !== null &&
                  data['web_app']['name'] !== undefined &&
                  data['web_app']['name'] !== ''
                    ? data['web_app']['name']
                    : data['cloud_agent_name'] !== undefined &&
                      data['cloud_agent_name'] !== null &&
                      data['cloud_agent_name'] !== ''
                    ? data['cloud_agent_name']
                    : data['endpoint_ip'] &&
                      data['endpoint_ip'] !== null &&
                      data['endpoint_ip'] !== ''
                    ? data['endpoint_ip']
                    : this.renderSastHostName.bind(this)(data)}
                </span>
                {data['cloud_agent_alias'] && (
                  <span
                    style={{ display: 'block', cursor: 'pointer' }}
                    title="alias"
                  >
                    <i>({data['cloud_agent_alias']})</i>
                  </span>
                )}
                {data['endpoint_alias'] && (
                  <span
                    style={{ display: 'block', cursor: 'pointer' }}
                    title="alias"
                  >
                    <i>({data['endpoint_alias']})</i>
                  </span>
                )}
              </td>
              <td>{vuln}</td>
              <td style={SeverityColor[data['severity']]}>
                {SeverityList[data['severity']]}
              </td>
              <td>
                {is_ignored ? (
                  <>
                    <text>IGNORED</text> <br />
                    <sub>
                      <span>({status})</span>
                    </sub>
                  </>
                ) : (
                  <text>{status}</text>
                )}
              </td>
              <td>
                {data['last_detected_date'] &&
                data['last_detected_date'].length > 0
                  ? moment(data['last_detected_date']).format('lll')
                  : ''}
              </td>
              <td>
                {data['last_tested_date'] && data['last_tested_date'].length > 0
                  ? moment(data['last_tested_date']).format('lll')
                  : ''}
              </td>
              <td
                className="text-right"
                style={{
                  minWidth: '50px',
                  maxWidth: '50px',
                  textAlign: 'left',
                }}
                title="View Vulnerability Status History"
              >
                <u>
                  <span
                    style={{ fontWeight: 'bolder', cursor: 'pointer' }}
                    onClick={() => {
                      this.setState({ status_history_finding_id: data['id'] });
                    }}
                  >
                    {data['age'] === undefined ||
                    data['age'] === null ||
                    data['age'].toString() === ''
                      ? '...'
                      : data['age']}
                  </span>
                </u>
                {data['lifecycle_count'] > 1 && (
                  <sup>*{data['lifecycle_count']}</sup>
                )}
              </td>
              <td>
                {this.renderAssignSelect.bind(this)(data, idx)}
                {data.assigned_member_id && data.assigned_member_id > 0 ? (
                  <Button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => {
                      // this.updateDueDate(data, null)
                      data.due_date = null;
                      this.unassignFinding.bind(this)(data);
                      data.assigned_member_id = '';
                      data.assigned_member_label = '';
                    }}
                    style={{
                      fontSize: '10px',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                      float: 'none',
                      width: '100%',
                    }}
                  >
                    Unassign
                  </Button>
                ) : (
                  ''
                )}
              </td>
              <td style={{ maxWidth: '95px', minWidth: '95px' }}>
                <div
                  title={
                    (this.isIgnoredStatusSelected()
                      ? 'Due Date cannot be added for ignored vulnerabilities'
                      : '') +
                    (!(data.assigned_member_id && data.assigned_member_id > 0)
                      ? '\nDue Date cannot be added when the assigned column is empty'
                      : '')
                  }
                >
                  <div
                    style={{ maxWidth: '95px', minWidth: '95px' }}
                    className="due-date custom-react-datepicker"
                  >
                    <DatePicker
                      selected={due_date}
                      disabled={
                        this.isIgnoredStatusSelected() ||
                        !(
                          data.assigned_member_id && data.assigned_member_id > 0
                        )
                      }
                      allowSameDay={true}
                      disabledKeyboardNavigation={true}
                      minDate={new Date()}
                      // dateFormat="MMMM d, yyyy h:mm aa"
                      onChange={(date) => {
                        data.due_date = date;
                        this.updateDueDate(data, date);
                      }}
                    />
                  </div>
                </div>
              </td>
              <td className="text-right finding-buttons-div">
                {this.renderButton.bind(this)(data)}
              </td>
            </tr>
          );
        })}
      </>
    );
  }

  renderNotification() {
    // const [open, setOpen] = React.useState(true);
    return (
      <>
        {/* <Collapse in={this.state.openModal === true}>
                <Alert severity={this.state.is_success === true ? "success" : "error"} action={
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => {
                            this.setState({ openModal: false });
                        }}
                    >
                        <CloseIcon fontSize="inherit" />
                    </IconButton>
                }>
                    <AlertTitle>{this.state.modalTitle}</AlertTitle>
                    {this.state.modalDetail}
                </Alert>
            </Collapse> */}
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </>
    );
  }
  renderTr(key, label, type) {
    if (
      this.state.currentReport[key] &&
      this.state.currentReport[key] !== '' &&
      this.state.currentReport[key] !== null
    ) {
      return (
        <tr>
          <td>{label}</td>
          {type === 'link' ? (
            <td>
              <a href={this.state.currentReport[key]} target="blank">
                {this.state.currentReport[key]}
              </a>
            </td>
          ) : (
            <td>
              <div
                dangerouslySetInnerHTML={{
                  __html: this.state.currentReport[key],
                }}
              ></div>
            </td>
          )}
        </tr>
      );
    }
  }
  renderBPRResultList(key, label, _type) {
    if (
      this.state.currentReport.source_type === 'bpr' &&
      this.state.currentReport[key] !== '' &&
      this.state.currentReport[key] !== undefined &&
      this.state.currentReport[key] !== {}
    ) {
      let currentReport = this.state.currentReport[key];
      let data = [];
      if (typeof currentReport === typeof []) {
        try {
          currentReport.forEach((item, i) => {
            data.push(<li>{item}</li>);
          });
          return (
            <tr>
              <td>{label}</td>
              <td>
                <ol>{data}</ol>
              </td>
            </tr>
          );
        } catch (e) {}
      }
    }
  }
  renderResultList(key, label, type) {
    if (
      this.state.currentReport[key] &&
      this.state.currentReport[key] !== '' &&
      this.state.currentReport[key] !== null
    ) {
      let currentReport = this.state.currentReport[key];
      let data = [];
      if (currentReport['list']) {
        data = currentReport['list'].map((item, index) => {
          if (type === 'accessPath' && item['Result']['accessPath']) {
            if (item['Result']['accessPath']['list']) {
              return item['Result']['accessPath']['list'].map(
                (_item, _index) => {
                  let preparedData = [];
                  let keys = Object.keys(_item);
                  for (let __index = 0; __index < keys.length; __index++) {
                    if (typeof _item[keys[__index]] === typeof {}) {
                      let _datum = _item[keys[__index]];
                      let _keys = Object.keys(_datum);
                      for (let __i = 0; __i < _keys.length; __i++) {
                        preparedData.push(
                          <tr>
                            <td>{keys[__index] + ' ' + _keys[__i]}</td>
                            <td>
                              {keys[__index].toLowerCase().indexOf('url') ===
                                0 ||
                              keys[__index].toLowerCase().indexOf('link') ? (
                                <a
                                  href={_item[keys[__index]][_keys[__i]]}
                                  target="new"
                                >
                                  {_item[keys[__index]][_keys[__i]]}
                                </a>
                              ) : (
                                <>{_item[keys[__index]][_keys[__i]]}</>
                              )}
                            </td>
                          </tr>,
                        );
                      }
                    } else if (typeof _item[keys[__index]] === typeof []) {
                    } else {
                      preparedData.push(
                        <tr>
                          <td>{keys[__index]}</td>
                          <td>
                            {keys[__index].toLowerCase().indexOf('url') === 0 ||
                            keys[__index].toLowerCase().indexOf('link') ? (
                              <a href={_item[keys[__index]]} target="new">
                                {_item[keys[__index]]}
                              </a>
                            ) : (
                              <>{_item[keys[__index]]}</>
                            )}
                          </td>
                        </tr>,
                      );
                    }
                  }
                  return (
                    <table className="table-striped">{preparedData}</table>
                  );
                },
              );
            }
          } else {
            if (item['Result']['payloads']['list']) {
              return item['Result']['payloads']['list'].map((_item, _index) => {
                if (
                  _item['PayloadInstance'] &&
                  _item['PayloadInstance']['request']
                ) {
                  return (
                    <table key={_index} className="table-striped">
                      <tr>
                        <td>Header</td>
                        <td>
                          {_item['PayloadInstance']['request']['headers']
                            ? atob(
                                _item['PayloadInstance']['request']['headers'],
                              )
                            : ''}
                        </td>
                      </tr>
                      <tr>
                        <td>Link</td>
                        <td>
                          <a
                            href={_item['PayloadInstance']['request']['link']}
                            target="blank"
                          >
                            {_item['PayloadInstance']['request']['link']}
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>Method</td>
                        <td>{_item['PayloadInstance']['request']['method']}</td>
                      </tr>
                      <tr>
                        <td>Response</td>
                        <td>{_item['PayloadInstance']['response']}</td>
                      </tr>
                    </table>
                  );
                }
              });
            }
          }
        });
        if (data.length > 0)
          return (
            <tr>
              <td>{label}</td>
              <td>
                <table className="table-striped">{data}</table>
              </td>
            </tr>
          );
      }
    }
  }
  renderStrucList(key, label, innerKey) {
    if (
      this.state.currentReport[key] &&
      this.state.currentReport[key] !== '' &&
      this.state.currentReport[key] !== null
    ) {
      let currentReport = this.state.currentReport[key];
      let data = [];
      if (innerKey === undefined) {
        innerKey = 'OWASP';
      }
      // if (currentReport['list']) {
      data = currentReport.map((item, index) => {
        if (item[innerKey]) {
          let owasp = item[innerKey];
          let keys = Object.keys(owasp);
          let innerData = [];
          for (let index = 0; index < keys.length; index++) {
            innerData.push(
              <tr>
                <td>{keys[index]}</td>
                <td>
                  {keys[index].toLowerCase().indexOf('link') === 0 ||
                  keys[index].toLowerCase().indexOf('url') === 0 ? (
                    <a href={owasp[keys[index]]} target="new">
                      {owasp[keys[index]]}
                    </a>
                  ) : (
                    <>{owasp[keys[index]]}</>
                  )}
                </td>
              </tr>,
            );
          }
          return <table className="table-striped">{innerData}</table>;
        }
      });
      if (data.length > 0)
        return (
          <tr>
            <td>{label}</td>
            <td>
              <table className="table-striped">{data}</table>
            </td>
          </tr>
        );
      // }
    }
  }
  renderNestedTr(key, label) {
    if (
      this.state.currentReport[key] &&
      this.state.currentReport[key] !== '' &&
      this.state.currentReport[key] !== null
    ) {
      let currentReport = this.state.currentReport[key];
      let keys = Object.keys(currentReport);
      let data = [];
      for (let index = 0; index < keys.length; index++) {
        if (typeof currentReport[keys[index]] === typeof {}) {
          let datum = '';
          if (typeof currentReport[keys[index]] === typeof '') {
            datum = currentReport[keys[index]];
          } else if (typeof currentReport[keys[index]] === typeof {}) {
            let __keys = Object.keys(currentReport[keys[index]]);
            datum = [];
            for (let __index = 0; __index < __keys.length; __index++) {
              let __datum = '';
              let __parsableData = currentReport[keys[index]][__keys[__index]];
              if (typeof __parsableData === typeof {}) {
                __datum = [];
                let ___keys = Object.keys(__parsableData);
                for (let ___index = 0; ___index < ___keys.length; ___index++) {
                  __datum.push(
                    <tr>
                      <td>{___keys[___index].split('_').join(' ')}</td>
                      <td>
                        {___keys[___index].toLowerCase().indexOf('link') ===
                          0 ||
                        ___keys[___index].toLowerCase().indexOf('url') === 0 ? (
                          <a
                            href={__parsableData[___keys[___index]]}
                            target="new"
                          >
                            {__parsableData[___keys[___index]]}
                          </a>
                        ) : (
                          <>{__parsableData[___keys[___index]]}</>
                        )}
                      </td>
                    </tr>,
                  );
                }
              } else {
                __datum = __parsableData;
              }
              datum.push(
                <tr>
                  <td>{__keys[__index].split('_').join(' ')}</td>
                  <td>
                    {moment(__datum).isValid() && typeof __datum !== 'number'
                      ? moment(__datum).format('lll')
                      : __datum}
                  </td>
                </tr>,
              );
            }
          }
          data.push(
            <tr>
              <td>{keys[index]}</td>
              <td>{datum}</td>
            </tr>,
          );
        } else if (typeof currentReport[keys[index]] === typeof []) {
          let innerData = currentReport[keys[index]];
          let innerRows = [];
          for (let index = 0; index < innerData.length; index++) {
            let innerKeys = Object.keys(innerData[index]);
            let _innerRow = [];
            for (let index = 0; index < innerKeys.length; index++) {
              _innerRow.push(
                <tr>
                  <td>{innerKeys[index].split('_').join(' ')}</td>
                  <td>
                    {innerKeys[index].toLowerCase().indexOf('link') === 0 ||
                    innerKeys[index].toLowerCase().indexOf('url') === 0 ? (
                      <a href={innerData[index][innerKeys[index]]} target="new">
                        {innerData[index][innerKeys[index]]}
                      </a>
                    ) : (
                      <>{innerData[index][innerKeys[index]]}</>
                    )}
                  </td>
                </tr>,
              );
            }
            innerRows.push(
              <table className="table-striped">{_innerRow}</table>,
            );
          }
          data.push(
            <tr>
              <td colSpan="2">
                <table className="table-striped">{innerRows}</table>
              </td>
            </tr>,
          );
        } else {
          data.push(
            <tr>
              <td>{keys[index].split('_').join(' ')}</td>
              <td>
                {moment(currentReport[keys[index]]).isValid() &&
                typeof currentReport[keys[index]] !== 'number'
                  ? moment(currentReport[keys[index]]).format('lll')
                  : currentReport[keys[index]]}
              </td>
            </tr>,
          );
        }
      }
      if (data.length > 0)
        return (
          <tr>
            <td>{label}</td>
            <td>
              <table className="table-striped">{data}</table>
            </td>
          </tr>
        );
    }
  }
  renderNestedArray(key, label) {
    if (
      this.state.currentReport[key] &&
      this.state.currentReport[key] !== '' &&
      this.state.currentReport[key] !== null &&
      !_.isEmpty(this.state.currentReport[key][0])
    ) {
      let data = [];
      if (key === 'vendor_reference_list' || key === 'cve_list') {
        data = this.state.currentReport[key].map((item, index) => {
          return (
            <div className="item-list">
              <a href={item.url} target="blank">
                {item.id}
              </a>
            </div>
          );
        });
      } else {
        data = this.state.currentReport[key].map((item, oindex) => {
          let innerTable = [],
            innerKeys = Object.keys(item);
          for (let index = 0; index < innerKeys.length; index++) {
            innerTable.push(
              <tr>
                <td>{innerKeys[index].split('_').join(' ')}</td>
                <td>
                  {moment(item[innerKeys[index]]).isValid() &&
                  typeof item[innerKeys[index]] !== 'number'
                    ? moment(item[innerKeys[index]]).format('lll')
                    : item[innerKeys[index]]}
                </td>
              </tr>,
            );
          }
          return <table className="table-striped">{innerTable}</table>;
        });
      }
      if (data.length > 0) {
        return (
          <tr>
            <td>{label}</td>
            <td>{data}</td>
          </tr>
        );
      }
    } else {
      return (
        <tr>
          <td>{label}</td>
          <td>N/A</td>
        </tr>
      );
    }
  }
  handleHostsChange(selectedOptions) {
    this.setState({ current_host: selectedOptions });
    let self = this;
    setTimeout(function () {
      self.fetchFindings();
    }, 100);
  }

  getFetchConfig(source_type_value) {
    const { scanner_type } = this.state;
    const { currentCompanyId } = this.props;
    let baseUrl = null;
    const additionalParams = {};

    switch (source_type_value) {
      case 'was_data':
        baseUrl = '/web_apps/';
        additionalParams['nutshell'] = 'true';
        additionalParams['company'] = currentCompanyId;
        additionalParams['is_active'] = 'true';
        break;
      case 'sast2':
        baseUrl = '/sast/repositories/host/';
        additionalParams['company_id'] = currentCompanyId;
        break;
      case 'endpoint_data':
      case 'endpoint_data_internal':
      case 'endpoint_data_external':
      case 'endpoint_data_ec2':
        baseUrl = '/endpoints/';
        additionalParams['nutshell'] = 'true';
        additionalParams['company'] = currentCompanyId;
        additionalParams['filter'] = 'active';
        if (scanner_type) additionalParams['scanner_type'] = scanner_type;
        break;
      case 'ca_data-all':
        baseUrl = '/cloud_agents/';
        additionalParams['nutshell'] = 'true';
        additionalParams['company'] = currentCompanyId;
        additionalParams['filter'] = 'active';
        break;
      case 'ca_data':
        baseUrl = '/cloud_agents/';
        additionalParams['nutshell'] = 'true';
        additionalParams['company'] = currentCompanyId;
        additionalParams['filter'] = 'active';
        additionalParams['server_or_workstation'] = 'Server';
        break;
      case 'ca_data-workstations':
        baseUrl = '/cloud_agents/';
        additionalParams['nutshell'] = 'true';
        additionalParams['company'] = currentCompanyId;
        additionalParams['filter'] = 'active';
        additionalParams['server_or_workstation'] = 'Workstations';
        break;
      default:
        baseUrl = null;
        break;
    }

    return { baseUrl, additionalParams };
  }

  renderHostOptions() {
    let { source_type, current_host, hostapps, scanner_type } = this.state;
    if (!this.props.currentCompanyId) return;

    const { baseUrl, additionalParams } = this.getFetchConfig(
      source_type.value,
    );
    // Key is required for cache, if key gots changed, option will reload
    // Added company id with key to update the host options when company changes
    let key = source_type.value + this.props.currentCompanyId;
    if (source_type.value === 'endpoint_data' && scanner_type) {
      key += scanner_type ?? 'all';
    }

    return (
      <>
        <Label>Host</Label>
        <InfiniteSelect
          fetcherFn={(search, page) =>
            fetchHosts({
              baseUrl: baseUrl,
              search,
              page,
              limit: HOSTS_LIMIT,
              additionalParams: additionalParams,
            })
          }
          cacheKey={key}
          onChange={this.handleHostsChange.bind(this)}
          value={current_host}
          isDisabled={source_type.value === ''}
          defaultOptions={hostapps}
          placeholder="Search hosts..."
          selectedLabel="Selected Host(s)"
          optionsLabel="Hosts"
          getOptionLabel={
            source_type.value === 'sast2'
              ? (option) => `${option.name}/${option.branch}`
              : (option) => option.label
          }
          getOptionValue={
            source_type.value === 'sast2'
              ? (option) => option.id
              : (option) => option.value
          }
        />
      </>
    );
  }
  renderCWE() {
    let cwe = this.state.currentReport.cwe,
      data = [];
    cwe.forEach((element) => {
      data.push(
        <a
          href={'https://cwe.mitre.org/data/definitions/' + element + '.html'}
          target="blank"
        >
          CWE-{element}
        </a>,
      );
    });
    return data;
  }
  renderContentAsRawJs() {
    const contentState = this.state.editorState.getCurrentContent();
    const raw = convertToRaw(contentState);
    const markdownString = draftToMarkdown(raw);
    return markdownString;
  }
  renderNotesContent() {
    let notes = this.state.notes.results;
    if (notes === undefined) notes = [];
    let data = notes.map((item, oindex) => {
      return (
        <Row key={oindex} style={{ marginBottom: '15px' }}>
          <Col md="12" className="spaced">
            <i className="custom-icon-text spaced">{item.initials}</i>
            {item.name} added a note on {moment(item.created_at).format('lll')}
          </Col>
          <Col md="12" className="spaced" style={{ paddingLeft: '58px' }}>
            <Markdown>{item.data}</Markdown>
          </Col>
        </Row>
      );
    });
    return (
      <Row>
        <Col md="12">{data}</Col>
      </Row>
    );
  }
  notesModal() {
    const { editorState } = this.state;

    // If the user changes block type before entering any text, we can
    // either style the placeholder or hide it. Let's just hide it now.
    let className = 'RichEditor-editor';
    var contentState = editorState.getCurrentContent();
    if (!contentState.hasText()) {
      if (contentState.getBlockMap().first().getType() !== 'unstyled') {
        className += ' RichEditor-hidePlaceholder';
      }
    }
    return (
      <Modal
        isOpen={this.state.notesmodal}
        toggle={this.toggleNotesModal.bind(this)}
        size="lg"
      >
        <ModalHeader toggle={this.toggleNotesModal.bind(this)}>
          Notes
        </ModalHeader>
        <ModalBody>
          {this.renderNotesContent.bind(this)()}
          <div className="editorContainer">
            <div className="RichEditor-root">
              <BlockStyleControls
                editorState={editorState}
                onToggle={this.toggleBlockType}
              />
              <InlineStyleControls
                editorState={editorState}
                onToggle={this.toggleInlineStyle}
              />
              <div className={className} onClick={this.focus}>
                <Editor
                  blockStyleFn={getBlockStyle}
                  customStyleMap={styleMap}
                  editorState={editorState}
                  handleKeyCommand={this.handleKeyCommand}
                  onChange={this.onChange}
                  onTab={this.onTab}
                  placeholder=""
                  ref="editor"
                  spellCheck={true}
                />
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            size="sm"
            onClick={() => this.toggleNotesModal.bind(this)()}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            size="sm"
            onClick={() => this.saveNote.bind(this)()}
          >
            Save
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
  async saveWatcherList() {
    if (this.state.current_watcher === undefined) {
      toast.error('No user selected', {});
      return;
    }
    this.selectRef.clearValue();
    let vuln_id = this.state.current_finding_id,
      watchers = this.state.watchers;
    let user_id = this.state.current_watcher.map((watcher) => watcher.id);
    let self = this;
    let watchers_options = this.state.watchers_options;
    this.setState({ loader: true });

    let url = `assignee_maps/add_watchers?user=${user_id}&finding=${vuln_id}`;
    await callApi(url, 'GET', {})
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            this.setState({
              loader: false,
            });
            res.data.watchers.forEach(function (watcher) {
              watchers.push(watcher);
              watchers_options = self.removeObjectWithId(
                watchers_options,
                watcher.user,
              );
            });
            this.setState({
              watchers: watchers,
              watchers_options: watchers_options,
              openModal: true,
              is_success: true,
              modalTitle: 'Success',
              modalDetail:
                'The User has been successfully added to the watchers list.',
            });
            toast.info(
              'Success! ' +
                'The User has been successfully added to the watchers list.',
              {
                position: 'bottom-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              },
            );
          }
        } else if (res.status === 422) {
        } else if (res.status === 401 || res.status === 400) {
        }
      })
      .catch((err) => {
        this.setState({ loader: false });
        let res = err.response;
        if (res.status === 401 || res.status === 400) {
        } else if (res.status === 200) {
        } else {
          this.setState({
            openModal: true,
            is_success: false,
            modalTitle: 'Error',
            modalDetail:
              'It seems the user has already been added to the watchers list',
          });
          toast.error(
            'Error! ' +
              'It seems the user has already been added to the watchers list',
            {
              position: 'bottom-right',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            },
          );
        }
      });
  }
  async removeWatcher(watcher) {
    let watchers = this.state.watchers;
    let watchers_options = this.state.watchers_options;
    this.setState({ loader: true });

    let url =
        process.env.REACT_APP_SERVER_PATH +
        '/assignee_maps/watchers/' +
        watcher.id +
        '/',
      data = {
        is_active: false,
      };
    callApi(url, 'PATCH', {}, data)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            this.setState({
              loader: false,
            });
            var member = this.state.members.filter((obj) => {
              return obj.users_id === watcher.user;
            });
            watchers_options.push(member[0]);
            watchers.splice(watchers.indexOf(watcher), 1);
            this.setState({
              watchers: watchers,
              openModal: true,
              is_success: true,
              modalTitle: 'Success',
              modalDetail:
                'Member has been successfully removed from watchers list',
            });
            toast.info(
              'Success! ' +
                'Member has been successfully removed from watchers list',
              {
                position: 'bottom-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              },
            );
          }
        } else if (res.status === 422) {
        }
      })
      .catch((err) => {
        this.setState({ loader: false });
        let res = err.response;
        if (res.status === 401 || res.status === 400) {
        } else if (res.status === 200) {
        } else {
          this.setState({
            openModal: true,
            is_success: false,
            modalTitle: 'Error',
            modalDetail:
              'It seems the user has already been removed from to the watcher list',
          });
          toast.error(
            'Error! ' +
              'It seems the user has already been removed from to the watcher list',
            {
              position: 'bottom-right',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            },
          );
        }
      })
      .finally(() => {
        this.setState({ loader: false });
      });
  }
  renderWatcherContent() {
    let watchers = this.state.watchers;
    let current_watcher = this.state.current_watcher,
      watcherData =
        watchers.length === 0 ? (
          <tr>
            <td colSpan="3">No watcher assigned to this Vulnerability</td>
          </tr>
        ) : (
          watchers.map((watcher, index) => {
            return (
              <tr key={index}>
                <td>
                  {watcher.first_name} {watcher.last_name}
                </td>
                <td>{watcher.email}</td>
                <td className="text-right">
                  <Button
                    color="secondary"
                    size="sm"
                    disabled={this.state.loader === true ? true : false}
                    onClick={() => this.removeWatcher.bind(this)(watcher)}
                  >
                    Remove
                  </Button>
                </td>
              </tr>
            );
          })
        );
    // watchers.push({name: '', email: ''})
    return (
      <>
        <Table className="tablesorter verticle-middle table-striped" responsive>
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th className="text-right">Action</th>
            </tr>
          </thead>
          <tbody>{watcherData}</tbody>
        </Table>
        <Row>
          <Col sm="12">Add new watcher</Col>
          <Col sm="9">
            <Select
              className="custom-360-dropdown profile-pic-dropdown"
              ref={(ref) => {
                this.selectRef = ref;
              }}
              closeMenuOnSelect={false}
              isMulti
              isClearable={true}
              hideSelectedOptions={true}
              onChange={(e) => {
                this.setState({ current_watcher: e });
              }}
              value={current_watcher}
              options={this.state.watchers_options}
            />
          </Col>
          <Col sm="3 text-right">
            <Button
              color="primary"
              size="sm"
              disabled={
                this.state.current_watcher === null ||
                this.state.current_watcher === undefined
                  ? true
                  : false
              }
              onClick={() => this.saveWatcherList.bind(this)()}
            >
              Save
            </Button>
          </Col>
        </Row>
      </>
    );
  }
  async updateDueDate(finding, due_date) {
    let local_due_date = due_date
      ? new Date(due_date.getTime() - due_date.getTimezoneOffset() * 60000)
      : null;
    this.setState({ loader: true });
    let url = '/findings/' + finding.id + '/',
      data = { due_date: local_due_date };

    callApi(url, 'PATCH', {}, data)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          this.setState({
            loader: false,
            openModal: true,
            is_success: true,
            modalTitle: 'Success',
            modalDetail:
              'The vulnerability due date has been successfully updated.',
          });
          toast.info(
            'Success! ' +
              'The vulnerability due date has been successfully updated.',
            {
              position: 'bottom-right',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            },
          );
        } else if (res.status === 422) {
          // console.log('Error')
          this.setState({
            loader: false,
          });
          this.setState({
            openModal: true,
            is_success: false,
            modalTitle: 'Error',
            modalDetail: res.data.detail,
          });
          toast.error('Error! ' + (res && res.data ? res.data.detail : ''), {
            position: 'bottom-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else if (res.status === 401 || res.status === 400) {
        }
      })
      .catch((err) => {
        this.setState({ loader: false });
        let res = err.response;
        if (res.status === 401 || res.status === 400) {
        } else if (res.status === 200) {
        } else if (res.status === 422) {
          this.setState({
            openModal: true,
            is_success: false,
            modalTitle: 'Error',
            modalDetail: res.data.detail,
          });
          toast.error('Error! ' + (res && res.data ? res.data.detail : ''), {
            position: 'bottom-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      })
      .finally(() => {
        this.setState({ loader: false });
      });
  }
  renderWatcherModel() {
    return (
      <Modal
        isOpen={this.state.watcher_modal}
        toggle={this.toggleWatcherModal.bind(this)}
        size="lg"
      >
        <ModalHeader toggle={this.toggleWatcherModal.bind(this)}>
          Vulnerability Watchers
        </ModalHeader>
        <ModalBody>{this.renderWatcherContent.bind(this)()}</ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            size="sm"
            onClick={() => this.toggleWatcherModal.bind(this)()}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

  renderIgnoreVulnModel() {
    return (
      <>
        {this.state.show_ignore_vuln_modal && (
          <IgnoreVulnModal
            findingData={this.state.ignore_finding_data}
            selectedHosts={this.getSelectedHostIds()}
            isOpen={this.state.show_ignore_vuln_modal}
            toggle={this.toggleIgnoreVulnModal.bind(this)}
            onSuccess={() => this.onIgnoreSuccess.bind(this)(true)}
            onFailure={(message) => console.log(message)}
          />
        )}
      </>
    );
  }

  renderUnIgnoreVulnModel() {
    return (
      <>
        {this.state.unignore_vuln_modal && (
          <UnignoreVulnModal
            findingData={this.state.unignore_finding_data}
            selectedHosts={this.getSelectedHostIds()}
            isOpen={this.state.unignore_vuln_modal}
            toggle={this.toggleUnignoreVulnModal.bind(this)}
            onSuccess={() => this.onIgnoreSuccess.bind(this)(false)}
            onFailure={(message) => console.log(message)}
          />
        )}
      </>
    );
  }

  isAllFieldsBlank() {
    if (
      this.state.last_detected_from_date === null &&
      this.state.last_detected_to_date === null &&
      this.state.last_tested_from_date === null &&
      this.state.last_tested_to_date === null &&
      this.state.due_from_date === null &&
      this.state.due_to_date === null &&
      this.state.qid === '' &&
      this.state.rule_id === '' &&
      this.state.created_from_date === null &&
      this.state.created_to_date === null &&
      this.state.reopened_from_date === null &&
      this.state.reopened_to_date === null &&
      this.state.fixed_from_date === null &&
      this.state.fixed_to_date === null &&
      this.state.ignored_from_date === null &&
      this.state.ignored_to_date === null &&
      this.state.age_min === '' &&
      this.state.age_min_inclusive === 1 &&
      this.state.age_max_inclusive === 1 &&
      this.state.age_max === ''
    ) {
      return true;
    } else {
      return false;
    }
  }
  removeAdvanceFilters() {
    this.setState({
      last_detected_from_date: null,
      last_detected_to_date: null,
      last_tested_from_date: null,
      last_tested_to_date: null,
      due_from_date: null,
      due_to_date: null,
      qid: '',
      rule_id: '',
      created_from_date: null,
      created_to_date: null,
      reopened_from_date: null,
      reopened_to_date: null,
      fixed_from_date: null,
      fixed_to_date: null,
      ignored_from_date: null,
      ignored_to_date: null,
      age_min: '',
      age_max: '',
      age_min_inclusive: 1,
      age_max_inclusive: 1,
    });
  }
  renderAdvanceSearchModel() {
    return (
      <Modal
        isOpen={this.state.advance_search_modal}
        toggle={this.toggleAdvanceSearchModal.bind(this)}
        size="md"
      >
        <ModalHeader toggle={this.toggleAdvanceSearchModal.bind(this)}>
          Advanced Filters
        </ModalHeader>
        <ModalBody>
          <Row style={{ marginBottom: '15px' }}>
            <Col md="4" className="spaced">
              <label>Last Detected Date</label>
            </Col>
            <Col md="4" className="spaced">
              <DatePicker
                selected={this.state.last_detected_from_date}
                isClearable
                placeholderText="From"
                timeInputLabel="Time:"
                timeFormat="HH:mm"
                dateFormat="MM-dd-yyyy HH:mm"
                showTimeInput
                onChange={(date) => {
                  this.setState({ last_detected_from_date: date });
                }}
                wrapperClassName="datePicker"
              />
            </Col>
            <Col md="4" className="spaced">
              <DatePicker
                style={{ width: '100%' }}
                selected={this.state.last_detected_to_date}
                isClearable
                placeholderText="To"
                timeInputLabel="Time:"
                timeFormat="HH:mm"
                dateFormat="MM-dd-yyyy HH:mm"
                showTimeInput
                onChange={(date) => {
                  this.setState({ last_detected_to_date: date });
                }}
                wrapperClassName="datePicker"
              />
            </Col>
          </Row>
          <Row style={{ marginBottom: '15px' }}>
            <Col md="4" className="spaced">
              <label>Last Tested Date</label>
            </Col>
            <Col md="4" className="spaced">
              <DatePicker
                style={{ width: '100%' }}
                selected={this.state.last_tested_from_date}
                isClearable
                placeholderText="From"
                timeInputLabel="Time:"
                timeFormat="HH:mm"
                dateFormat="MM-dd-yyyy HH:mm"
                showTimeInput
                onChange={(date) => {
                  this.setState({ last_tested_from_date: date });
                }}
                wrapperClassName="datePicker"
              />
            </Col>
            <Col md="4" className="spaced">
              <DatePicker
                style={{ width: '100%' }}
                selected={this.state.last_tested_to_date}
                isClearable
                placeholderText="To"
                timeInputLabel="Time:"
                timeFormat="HH:mm"
                dateFormat="MM-dd-yyyy HH:mm"
                showTimeInput
                onChange={(date) => {
                  this.setState({ last_tested_to_date: date });
                }}
                wrapperClassName="datePicker"
              />
            </Col>
          </Row>
          <Row style={{ marginBottom: '15px' }}>
            <Col md="4" className="spaced">
              <label>Due Date</label>
            </Col>
            <Col md="4" className="spaced">
              <DatePicker
                style={{ width: '100%' }}
                selected={this.state.due_from_date}
                isClearable
                placeholderText="From"
                timeInputLabel="Time:"
                timeFormat="HH:mm"
                dateFormat="MM-dd-yyyy HH:mm"
                showTimeInput
                onChange={(date) => {
                  this.setState({ due_from_date: date });
                }}
                wrapperClassName="datePicker"
              />
            </Col>
            <Col md="4" className="spaced">
              <DatePicker
                style={{ width: '100%' }}
                selected={this.state.due_to_date}
                isClearable
                placeholderText="To"
                timeInputLabel="Time:"
                timeFormat="HH:mm"
                dateFormat="MM-dd-yyyy HH:mm"
                showTimeInput
                onChange={(date) => {
                  this.setState({ due_to_date: date });
                }}
                wrapperClassName="datePicker"
              />
            </Col>
          </Row>
          <Row style={{ marginBottom: '15px' }}>
            <Col md="4" className="spaced">
              <label>Created Date</label>
            </Col>
            <Col md="4" className="spaced">
              <DatePicker
                style={{ width: '100%' }}
                selected={this.state.created_from_date}
                isClearable
                placeholderText="From"
                timeInputLabel="Time:"
                timeFormat="HH:mm"
                dateFormat="MM-dd-yyyy HH:mm"
                showTimeInput
                onChange={(date) => {
                  this.setState({ created_from_date: date });
                }}
                wrapperClassName="datePicker"
              />
            </Col>
            <Col md="4" className="spaced">
              <DatePicker
                style={{ width: '100%' }}
                selected={this.state.created_to_date}
                isClearable
                placeholderText="To"
                timeInputLabel="Time:"
                timeFormat="HH:mm"
                dateFormat="MM-dd-yyyy HH:mm"
                showTimeInput
                onChange={(date) => {
                  this.setState({ created_to_date: date });
                }}
                wrapperClassName="datePicker"
              />
            </Col>
          </Row>
          <Row style={{ marginBottom: '15px' }}>
            <Col md="4" className="spaced">
              <label>Reopened Date </label>
            </Col>
            <Col md="4" className="spaced">
              <DatePicker
                style={{ width: '100%' }}
                selected={this.state.reopened_from_date}
                isClearable
                placeholderText="From"
                timeInputLabel="Time:"
                timeFormat="HH:mm"
                dateFormat="MM-dd-yyyy HH:mm"
                showTimeInput
                onChange={(date) => {
                  this.setState({ reopened_from_date: date });
                }}
                wrapperClassName="datePicker"
              />
            </Col>
            <Col md="4" className="spaced">
              <DatePicker
                style={{ width: '100%' }}
                selected={this.state.reopened_to_date}
                isClearable
                placeholderText="To"
                timeInputLabel="Time:"
                timeFormat="HH:mm"
                dateFormat="MM-dd-yyyy HH:mm"
                showTimeInput
                onChange={(date) => {
                  this.setState({ reopened_to_date: date });
                }}
                wrapperClassName="datePicker"
              />
            </Col>
          </Row>
          <Row style={{ marginBottom: '15px' }}>
            <Col md="4" className="spaced">
              <label>Fixed Date</label>
            </Col>
            <Col md="4" className="spaced">
              <DatePicker
                style={{ width: '100%' }}
                selected={this.state.fixed_from_date}
                isClearable
                placeholderText="From"
                timeInputLabel="Time:"
                timeFormat="HH:mm"
                dateFormat="MM-dd-yyyy HH:mm"
                showTimeInput
                onChange={(date) => {
                  this.setState({ fixed_from_date: date });
                }}
                wrapperClassName="datePicker"
              />
            </Col>
            <Col md="4" className="spaced">
              <DatePicker
                style={{ width: '100%' }}
                selected={this.state.fixed_to_date}
                isClearable
                placeholderText="To"
                timeInputLabel="Time:"
                timeFormat="HH:mm"
                dateFormat="MM-dd-yyyy HH:mm"
                showTimeInput
                onChange={(date) => {
                  this.setState({ fixed_to_date: date });
                }}
                wrapperClassName="datePicker"
              />
            </Col>
          </Row>
          <Row style={{ marginBottom: '15px' }}>
            <Col md="4" className="spaced">
              <label>Ignored Date</label>
            </Col>
            <Col md="4" className="spaced">
              <DatePicker
                style={{ width: '100%' }}
                selected={this.state.ignored_from_date}
                isClearable
                placeholderText="From"
                timeInputLabel="Time:"
                timeFormat="HH:mm"
                dateFormat="MM-dd-yyyy HH:mm"
                showTimeInput
                onChange={(date) => {
                  this.setState({ ignored_from_date: date });
                }}
                wrapperClassName="datePicker"
              />
            </Col>
            <Col md="4" className="spaced">
              <DatePicker
                style={{ width: '100%' }}
                selected={this.state.ignored_to_date}
                isClearable
                placeholderText="To"
                timeInputLabel="Time:"
                timeFormat="HH:mm"
                dateFormat="MM-dd-yyyy HH:mm"
                showTimeInput
                onChange={(date) => {
                  this.setState({ ignored_to_date: date });
                }}
                wrapperClassName="datePicker"
              />
            </Col>
          </Row>
          <Row style={{ marginBottom: '15px' }}>
            <Col md="4" className="spaced">
              <label>Age</label>
            </Col>
            <Col md="4" className="spaced">
              <InputGroup style={{ backgroundColor: 'white' }}>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText
                    style={{
                      height: '40px',
                      paddingLeft: 0,
                      borderRadius: '0',
                    }}
                  >
                    <Input
                      addon
                      type="select"
                      title={`GT: Greater than\nGTE: Greater than or equal to`}
                      style={{
                        color: 'black',
                        border: '0',
                        paddingLeft: '12px',
                        paddingRight: '12px',
                        WebkitAppearance: 'none',
                      }}
                      value={this.state.age_min_inclusive}
                      onChange={(e) => {
                        this.setState({
                          age_min_inclusive: parseInt(e.target.value),
                        });
                      }}
                    >
                      <option
                        style={{ color: 'black', backgroundColor: 'white' }}
                        value={0}
                      >
                        GT
                      </option>
                      <option
                        style={{ color: 'black', backgroundColor: 'white' }}
                        value={1}
                      >
                        GTE
                      </option>
                    </Input>
                  </InputGroupText>
                </InputGroupAddon>
                <div
                  style={{
                    backgroundColor: '#525f7f',
                    height: '40px',
                    width: '1px',
                  }}
                ></div>
                <Input
                  type="number"
                  style={{ borderRadius: '0', height: '40px', color: 'black' }}
                  value={this.state.age_min}
                  placeholder="Min"
                  min="0"
                  max="10000"
                  onChange={(e) => {
                    this.setState({
                      age_min: parseInt(e.target.value),
                    });
                  }}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
              </InputGroup>
            </Col>
            <Col md="4" className="spaced">
              <InputGroup style={{ backgroundColor: 'white' }}>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText
                    style={{
                      height: '40px',
                      paddingLeft: 0,
                      borderRadius: '0',
                    }}
                  >
                    <Input
                      addon
                      type="select"
                      title={`LT: Less than\nLTE: Less than or equal to`}
                      style={{
                        color: 'black',
                        border: '0',
                        paddingLeft: '12px',
                        paddingRight: '12px',
                        WebkitAppearance: 'none',
                      }}
                      value={this.state.age_max_inclusive}
                      onChange={(e) => {
                        this.setState({
                          age_max_inclusive: parseInt(e.target.value),
                        });
                      }}
                    >
                      <option
                        style={{ color: 'black', backgroundColor: 'white' }}
                        value={0}
                      >
                        LT
                      </option>
                      <option
                        style={{ color: 'black', backgroundColor: 'white' }}
                        value={1}
                      >
                        LTE
                      </option>
                    </Input>
                  </InputGroupText>
                </InputGroupAddon>
                <div
                  style={{
                    backgroundColor: '#525f7f',
                    height: '40px',
                    width: '1px',
                  }}
                ></div>
                <Input
                  type="number"
                  style={{ borderRadius: '0', height: '40px', color: 'black' }}
                  value={this.state.age_max}
                  placeholder="Max"
                  min="0"
                  max="10000"
                  onChange={(e) => {
                    this.setState({
                      age_max: parseInt(e.target.value),
                    });
                  }}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
              </InputGroup>
            </Col>
          </Row>
          <Row style={{ marginBottom: '15px' }}>
            <Col md="4" className="spaced">
              <label>Qualys Id</label>
            </Col>
            <Col md="4" className="spaced">
              <Input
                type="text"
                style={{
                  borderRadius: '0',
                  backgroundColor: 'white',
                  color: 'black',
                }}
                value={this.state.qid}
                placeholder="Search QID"
                onChange={(e) => {
                  this.setState({
                    qid: e.target.value,
                  });
                }}
              />
            </Col>
          </Row>
          <Row style={{ marginBottom: '15px' }}>
            <Col md="4" className="spaced">
              <label>SAST Rule Id</label>
            </Col>
            <Col md="4" className="spaced">
              <Input
                type="text"
                style={{
                  borderRadius: '0',
                  backgroundColor: 'white',
                  color: 'black',
                }}
                value={this.state.rule_id}
                placeholder="Search SAST Rule Id"
                onChange={(e) => {
                  this.setState({
                    rule_id: e.target.value,
                  });
                }}
              />
            </Col>
          </Row>
          <Row style={{ textAlign: 'justify' }}>
            <Col md="1" className="spaced">
              <p>
                <strong>NOTE:</strong>
              </p>
            </Col>
            <Col md="11" className="spaced">
              <p>
                With the exception of the Qualys ID and SAST Rule ID filters
                which are logically &quot;ORed&quot; with each other, all other
                Advanced Filters are logically &quot;ANDed&quot; with each
                other, as well as with the non-advanced filters to refine search
                results.
              </p>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            size="sm"
            onClick={() => this.toggleAdvanceSearchModal.bind(this)()}
          >
            Cancel
          </Button>
          {this.isAllFieldsBlank() ? (
            <Button disabled color="disabled" size="sm">
              Remove Advanced Filters
            </Button>
          ) : (
            <Button
              color="primary"
              size="sm"
              onClick={(e) => {
                e.preventDefault();
                this.removeAdvanceFilters();
              }}
            >
              Remove Advanced Filters
            </Button>
          )}
          <Button
            color="primary"
            size="sm"
            onClick={() => this.fetchFindings.bind(this)()}
          >
            Apply
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

  capitalizeWords(str) {
    return str.toLowerCase().replace(/(?:^|\s)\w/g, function (word) {
      return word.toUpperCase();
    });
  }

  processIgnoreMessage(json) {
    let ignoredInfo = '';
    if (json.is_ignored) {
      ignoredInfo += 'Yes';
      if (json.ignored_date || json.ignored_by) {
        ignoredInfo += ` (${
          json.ignored_date
            ? 'Ignored at ' + moment(json.ignored_date).format('lll') + ', '
            : ''
        }${json.ignored_by ? 'by ' + json.ignored_by : ''})`;
      }
    } else {
      ignoredInfo += 'No';
      if (json.unignored_date || json.unignored_by) {
        ignoredInfo += ` (${
          json.unignored_date
            ? 'Unignored at ' + moment(json.unignored_date).format('lll') + ', '
            : ''
        }${json.unignored_by ? 'by ' + json.unignored_by : ''})`;
      }
    }
    if (json.is_ignored) {
      ignoredInfo += `<br/>Reason: ${
        json.ignored_reason || ''
      } <br/> Comments and Details: ${json.ignored_comments || ''}`;
    }
    return ignoredInfo;
  }

  processJSON(json) {
    if (!json && Object.keys(json).length === 0) return null;
    let webAppJson = {};
    let commonJson = {};
    // Process json for Web Apps Data Here
    if (json.source_type === 'was_data') {
      // Web App: Add new access_path key and assign the Results->accessPath.list
      const accessPathList =
        Object.keys(json.result_list).length &&
        json.result_list.list[0].Result?.accessPath?.list;

      // Web App: Add new payload key and flat request fields to the PayloadInstance object
      const payloadList = Object.keys(json.result_list).length
        ? json.result_list.list[0].Result?.payloads?.list
        : null;
      const payloadFlatList = payloadList
        ? payloadList.map((payloadObj) => {
            const { link, method, headers } =
              payloadObj.PayloadInstance.request;
            let payload = payloadObj.PayloadInstance.payload;
            payload = payload && payload !== 'N/A' ? payload : undefined;

            return {
              PayloadInstance: {
                payload: payload && payload,
                request: {
                  link,
                  method,
                  headers,
                },
                response: payloadObj.PayloadInstance.response,
              },
            };
          })
        : null;
      // Web App: convert cwe array to list of object with url and id
      const cwe = json.cwe;
      const cweListUrl = cwe
        ? cwe.map((id) => {
            return {
              id: `CWE-${id}`,
              url: `https://cwe.mitre.org/data/definitions/${id}.html`,
            };
          })
        : [];
      // Web App: convert owasp, wasc array to proper list format
      const owaspList = json.owasp;
      const wascList = json.wasc;

      webAppJson = {
        payload: { list: payloadFlatList },
        access_path: { list: accessPathList },
        owasp: { list: owaspList },
        wasc: { list: wascList },
        cwe: cweListUrl,
      };
    }
    // Common: Ignore comment
    let ignoreMessage = this.processIgnoreMessage(json);

    // Common: Severity 1: Minimal 2: Medium 3: Serious 4: Critical 5: Urgent
    let severity;
    switch (json?.severity) {
      case 1:
        severity = 'Minimal';
        break;
      case 2:
        severity = 'Medium';
        break;
      case 3:
        severity = 'Serious';
        break;
      case 4:
        severity = 'Critical';
        break;
      case 5:
        severity = 'Urgent';
        break;
      default:
        severity = null;
    }

    commonJson = {
      severity: severity,
      ignore_message: ignoreMessage,
    };

    // Create the final processed object
    const processedObj = {
      ...json,
      // Web Apps
      ...webAppJson,
      //   Common
      ...commonJson,
    };

    return processedObj;
  }

  detailModal() {
    const processedData = this.processJSON(this.state.currentReport);

    return (
      <Modal
        isOpen={this.state.modal}
        toggle={this.toggle.bind(this)}
        size="lg"
        className="modal-dialog-70"
      >
        <ModalHeader toggle={this.toggle.bind(this)}>
          {this.state.currentReport && this.state.currentReport.issue_type
            ? this.capitalizeWords(this.state.currentReport.issue_type)
            : ''}{' '}
          Detail
        </ModalHeader>
        <ModalBody>
          {this.state.currentReport && (
            <FindingDetailModal data={processedData} />
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            size="sm"
            onClick={() => this.toggle.bind(this)()}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

  debouncedSearch = debounce(() => {
    let self = this;
    setTimeout(function () {
      self.fetchFindings();
    }, 60);
  }, 1000);

  handleChange(e) {
    let input = e.target.value;
    this.setState({
      company_search_data: input,
    });
    this.debouncedSearch();
  }

  getHostTypeValue = (source_type) => {
    // hack: select the correct endpoint option under the drop down
    if (source_type.value === 'endpoint_data') {
      let scanner_type = this.state.scanner_type;
      if (scanner_type === 'External')
        return {
          value: 'endpoint_data_external',
          label: source_type.label,
        };
      else if (scanner_type === 'Internal')
        return {
          value: 'endpoint_data_internal',
          label: source_type.label,
        };
      else if (scanner_type === 'EC2')
        return {
          value: 'endpoint_data_ec2',
          label: source_type.label,
        };
    }
    return source_type;
  };

  handleStatusChange = (e) => {
    // CHECK JIRA ISSUE FOR FIXED VIEW ORDERING DETAILS
    // https://securepoint360.atlassian.net/browse/SB-577?focusedCommentId=11755
    let status_values = e?.map((status) => status.value);
    let ordering = this.state.ordering;
    // endpoint default ordering
    let default_fixed_vuln_ordering = `${FIXED_VULN_ORDERING_1},${FIXED_VULN_ORDERING_2_FOR_EP}`;
    // non endpoint ordering
    if (this.state.source_type !== 'endpoint_data') {
      default_fixed_vuln_ordering = `${FIXED_VULN_ORDERING_1},${FIXED_VULN_ORDERING_2_FOR_NON_EP}`;
    }

    // console.log(this.state.statuses);
    // console.log('this.state.statuses');

    let statuses = _.clone(e);
    const allPreviouslySelected = this.state.statuses?.find(
      (status) => status.value === 'all',
    );
    const allNowSelected = status_values.includes('all');

    const allOpenPreviouslySelected = this.state.statuses?.find(
      (status) => status.value === 'open',
    );
    const allOpenNowSelected = status_values.includes('open');

    const allClosedPreviouslySelected = this.state.statuses?.find(
      (status) => status.value === 'closed',
    );
    const allClosedNowSelected = status_values.includes('closed');

    const noneSelected = !e || e.length === 0;

    // if all value is newly selected, deselect all other
    if (allNowSelected && !allPreviouslySelected) {
      statuses = StatusOptions.filter((x) => x.value === 'all');
    } else if (
      (allOpenNowSelected && !allOpenPreviouslySelected) ||
      noneSelected
    ) {
      // group status is selected, so deselect all others
      statuses = StatusOptions.filter((x) => x.value === 'open');
    } else if (allClosedNowSelected && !allClosedPreviouslySelected) {
      // group status is selected, so deselect all others
      statuses = StatusOptions.filter((x) => x.value === 'closed');
    } else {
      // an individual status is selected, so deselect all group statuses
      statuses = e.filter(
        (x) => x.value !== 'all' && x.value !== 'open' && x.value !== 'closed',
      );
    }

    if (status_values.includes('fixed') || status_values.includes('closed')) {
      if (ordering === DEFAULT_ORDERING) {
        ordering = default_fixed_vuln_ordering;
      }
    } else if (ordering === default_fixed_vuln_ordering) {
      ordering = DEFAULT_ORDERING;
    }

    // console.log(statuses);

    this.setState({ statuses: statuses, ordering });

    let self = this;
    setTimeout(function () {
      self.fetchFindings();
    }, 100);
  };

  render() {
    // let tagData = this.state.tagData;
    let {
      selectedSeverityOption,
      statuses,
      source_type,
      selectedCategoryOption,
      selectedIssueTypeOption,
      status_history_finding_id,
    } = this.state;

    return (
      <>
        <div className="content main-panel">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <Row>
                    <Col xl="7" md="7" sm="12">
                      <h4>
                        Vulnerabilities
                        <label className="label btn">{this.state.count}</label>
                      </h4>
                    </Col>
                    <Col xl="5" md="5" sm="12">
                      <Row className="justify-content-end">
                        <Col
                          xl="1"
                          md="1"
                          sm="6"
                          className="d-flex align-items-center justify-content-end"
                        >
                          <FileDownloaderButton
                            buttonId="vuln_export_all"
                            iconClass="fa fa-file-export"
                            tooltip={
                              source_type.value === ''
                                ? 'Select a specific Host Type to export vulnerabilities.'
                                : 'Export vulnerabilities data for selected host type'
                            }
                            fileName={`${localStorage
                              .getItem('currentCompany')
                              ?.toLocaleLowerCase()}_${
                              this.state.source_type.value
                            }_vulnerabilities.csv`}
                            method="GET"
                            disabled={source_type.value === ''}
                            downloadUrl={
                              this.props.currentCompanyId
                                ? this.appendParamsToUrl(
                                    'findings/export-csv',
                                    this.getFetchFindingsUrlParams(
                                      this.props.currentCompanyId,
                                    ),
                                  )
                                : ''
                            }
                            className="float-right"
                            urlParams={{}}
                            onSuccessCallback={() =>
                              toast.success(
                                'Success! File download completed.',
                                {
                                  position: 'bottom-right',
                                  autoClose: 5000,
                                  hideProgressBar: false,
                                  closeOnClick: true,
                                  pauseOnHover: true,
                                  draggable: true,
                                  progress: undefined,
                                },
                              )
                            }
                            onFailureCallback={(message) =>
                              toast.error('Error! ' + message, {
                                position: 'bottom-right',
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                              })
                            }
                          />
                        </Col>
                        <Col xl="5" md="5" sm="5" className="text-right p-2">
                          {/* <Label>Search</Label> */}
                          <Input
                            type="text"
                            list="data"
                            value={this.state.company_search_data}
                            placeholder="Search"
                            onChange={(e) => {
                              this.handleChange(e);
                            }}
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col xl="12" md="12" sm="12" className="text-right">
                      <Row>
                        <Col
                          className="text-left px-2"
                          style={{ minWidth: '85px' }}
                        >
                          <Label>Host&nbsp;Type</Label>
                          <Select
                            className="custom-360-dropdown"
                            value={this.getHostTypeValue(source_type)}
                            onChange={(e) => {
                              // e.preventDefault()
                              let selectedElement = {
                                value: e.value,
                                label: e.label,
                              };

                              let scanner_type = null;
                              if (e.value === 'endpoint_data_external') {
                                scanner_type = 'External';
                                // hack: reset the selected element value, to avoid changes on other locations
                                selectedElement.value = 'endpoint_data';
                              } else if (e.value === 'endpoint_data_internal') {
                                scanner_type = 'Internal';
                                // hack: reset the selected element value, to avoid changes on other locations
                                selectedElement.value = 'endpoint_data';
                              } else if (e.value === 'endpoint_data_ec2') {
                                scanner_type = 'EC2';
                                // hack: reset the selected element value, to avoid changes on other locations
                                selectedElement.value = 'endpoint_data';
                              }
                              // NOTE: In 'ALL' case
                              if (e.value == '') {
                                this.removeAdvanceFilters();
                              }

                              this.setState({
                                source_type: selectedElement,
                                current_host: null,
                                company_search_data: '',
                                issue_type: '',
                                selectedIssueTypeOption: {
                                  value: '',
                                  label: 'All',
                                },
                                scanner_type: scanner_type,
                                hostapps: [],
                              });
                              let self = this;
                              setTimeout(function () {
                                if (selectedElement.value) {
                                  self.fetchHostsWithSourceType(
                                    selectedElement.value,
                                  );
                                } else {
                                  self.fetchFindings();
                                }
                              }, 100);
                            }}
                            styles={colourStyles}
                            options={this.state.SourceType}
                          />
                        </Col>
                        <Col
                          className="text-left px-2 custom-360-dropdown"
                          style={{ minWidth: '180px' }}
                        >
                          {this.renderHostOptions()}
                        </Col>
                        <Col
                          className="text-left px-2 custom-360-dropdown"
                          style={{ minWidth: '160px' }}
                        >
                          <Label>Status</Label>
                          <StatusMultiSelect
                            isDisabled={source_type.value !== ''}
                            options={StatusOptions}
                            values={statuses}
                            onChange={(e) => this.handleStatusChange(e)}
                          />
                        </Col>
                        <Col
                          className="text-left tooltip-lg px-2"
                          style={{ minWidth: '' }}
                        >
                          <Label>
                            Issue&nbsp;Type
                            {/* <i
                                                                className="tim-icons icon-alert-circle-exc"
                                                                style={{marginLeft: '5px'}}
                                                                id='severity-explaination'
                                                            ></i> */}
                          </Label>
                          <Select
                            className="custom-360-dropdown"
                            value={
                              ['', 'sast', 'sast2'].includes(
                                this.state.source_type.value,
                              )
                                ? selectedIssueTypeOption
                                : {
                                    value: 'VULNERABILITY',
                                    label: 'Vulnerability',
                                  }
                            }
                            isDisabled={
                              !['', 'sast', 'sast2'].includes(
                                this.state.source_type.value,
                              )
                            }
                            onChange={(e) => {
                              this.setState({
                                selectedIssueTypeOption: e,
                                issue_type: e.value,
                              });
                              let self = this;
                              setTimeout(function () {
                                self.fetchFindings();
                              }, 100);
                            }}
                            styles={colourStyles}
                            options={
                              ['', 'sast', 'sast2'].includes(
                                this.state.source_type.value,
                              )
                                ? SAST_ISSUE_TYPES
                                : ISSUE_TYPES
                            }
                          />
                        </Col>
                        <Col
                          sm="6"
                          className="text-left tooltip-lg px-2 custom-360-dropdown"
                          style={{ minWidth: '140px', maxWidth: '180px' }}
                        >
                          <Label>
                            Severity
                            <i
                              className="tim-icons icon-alert-circle-exc"
                              style={{ marginLeft: '5px' }}
                              id="severity-explaination"
                            ></i>
                          </Label>
                          <CustomMultiSelect
                            // isDisabled={source_type.value !== ''}
                            options={severities}
                            values={selectedSeverityOption}
                            onChange={(e) => {
                              this.setState({ selectedSeverityOption: e });
                              let self = this;
                              setTimeout(function () {
                                self.fetchFindings();
                              }, 100);
                            }}
                          />
                          <UncontrolledTooltip
                            placement="bottom"
                            target={'severity-explaination'}
                          >
                            <Table
                              className="tablesorter table-striped text-left"
                              responsive
                              style={{ maxWidth: 'calc(40vw)' }}
                            >
                              <thead>
                                <tr>
                                  <th style={{ color: 'black' }}>Level</th>
                                  <th style={{ color: 'black' }}>
                                    Description
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td style={{ color: 'black' }}>Minimal</td>
                                  <td style={{ color: 'black' }}>
                                    Intruders can collect information about the
                                    host (open ports, services, etc.) and may be
                                    able to use this information to find other
                                    vulnerabilities.
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ color: 'black' }}>Medium</td>
                                  <td style={{ color: 'black' }}>
                                    Intruders may be able to collect sensitive
                                    information from the host, such as the
                                    precise version of software installed. With
                                    this information, intruders can easily
                                    exploit known vulnerabilities specific to
                                    software versions.
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ color: 'black' }}>Serious</td>
                                  <td style={{ color: 'black' }}>
                                    Intruders may be able to gain access to
                                    specific information stored on the host,
                                    including security settings. This could
                                    result in potential misuse of the host by
                                    intruders. For example, vulnerabilities at
                                    this level may include partial disclosure of
                                    file contents, access to certain files on
                                    the host, directory browsing, disclosure of
                                    filtering rules and security mechanisms,
                                    denial of service attacks, and unauthorized
                                    use of services, such as mail-relaying.
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ color: 'black' }}>Critical</td>
                                  <td style={{ color: 'black' }}>
                                    Intruders can possibly gain control of the
                                    host, or there may be potential leakage of
                                    highly sensitive information. For example,
                                    vulnerabilities at this level may include
                                    full read access to files, potential
                                    backdoors, or a listing of all the users on
                                    the host.
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ color: 'black' }}>Urgent</td>
                                  <td style={{ color: 'black' }}>
                                    Intruders can easily gain control of the
                                    host, which can lead to the compromise of
                                    your entire network security. For example,
                                    vulnerabilities at this level may include
                                    full read and write access to files, remote
                                    execution of commands, and the presence of
                                    backdoors.
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </UncontrolledTooltip>
                        </Col>
                        <Col
                          md="1"
                          className="text-left px-2"
                          style={{ minWidth: '110px' }}
                        >
                          <Label>Predefined&nbsp;Filters</Label>
                          <Select
                            className="custom-360-dropdown"
                            value={selectedCategoryOption}
                            onChange={(e) => {
                              this.setState({ selectedCategoryOption: e });
                              let self = this;
                              setTimeout(function () {
                                self.fetchFindings();
                              }, 100);
                            }}
                            styles={colourStyles}
                            options={
                              this.state.source_type.value === 'sast' ||
                              this.state.source_type.value === 'bpr'
                                ? NON_QUALYS_CATEGORIES
                                : CATEGORIES
                            }
                          />
                        </Col>
                        <Col
                          md="1"
                          className="text-left tooltip-lg px-2 custom-360-dropdown"
                          style={{ minWidth: '110px' }}
                        >
                          <Label>Advanced&nbsp;Filters</Label>
                          <Button
                            color="primary"
                            size="sm"
                            className="btn-block"
                            style={{
                              marginTop: '0px',
                            }}
                            onClick={() =>
                              this.openAdvanceSearchModal.bind(this)()
                            }
                          >
                            <i className="fas fa-filter"></i>
                            <span
                              className="item-title"
                              style={{
                                display: 'inline-block',
                                marginLeft: '5px',
                              }}
                            >
                              {' '}
                              /
                            </span>
                            <span
                              style={{
                                display: 'inline-block',
                                fontSize: '15px',
                                fontWeight: 'bold',
                                paddingTop: '5px',
                                paddingBottom: '5px',
                                marginLeft: '5px',
                              }}
                            >
                              {this.state.advance_search_filters_count}
                            </span>
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </CardHeader>
                {this.state.count == 0 && <NoRecordFound />}
                {this.state.count != 0 && (
                  <CardBody>
                    <TableWithStickyHeader>
                      <thead className="text-primary">
                        <tr className="thead">
                          {/* <th>ID</th> */}
                          <th
                            onClick={() => {
                              this.orderBy('qid');
                            }}
                          >
                            Id
                            <i
                              className={
                                this.state.ordering === 'qid'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering === '-qid'
                                  ? 'fa fa-sort-amount-up'
                                  : 'fa fa-sort'
                              }
                            ></i>
                          </th>
                          <th
                            onClick={() => {
                              this.orderBy('source_type');
                            }}
                          >
                            Host type
                            <i
                              className={
                                this.state.ordering === 'source_type'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering === '-source_type'
                                  ? 'fa fa-sort-amount-up'
                                  : 'fa fa-sort'
                              }
                            ></i>
                          </th>
                          <th
                            onClick={() => {
                              this.orderBy('name');
                            }}
                          >
                            Name
                            <i
                              className={
                                this.state.ordering === 'name'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering === '-name'
                                  ? 'fa fa-sort-amount-up'
                                  : 'fa fa-sort'
                              }
                            ></i>
                          </th>
                          <th
                            onClick={() => {
                              if (
                                this.state.source_type.value === 'endpoint_data'
                              ) {
                                this.orderBy('big_ip');
                              } else {
                                this.orderBy('url,cloud_agent_name');
                              }
                            }}
                          >
                            Host
                            {this.state.source_type === 'endpoint_data' && (
                              <i
                                className={
                                  this.state.ordering ===
                                  FIXED_VULN_ORDERING_2_FOR_EP
                                    ? 'fa fa-sort-amount-down'
                                    : this.state.ordering ===
                                      `-${FIXED_VULN_ORDERING_2_FOR_EP}}`
                                    ? 'fa fa-sort-amount-up'
                                    : 'fa fa-sort'
                                }
                              ></i>
                            )}
                            {this.state.source_type !== 'endpoint_data' && (
                              <i
                                className={
                                  this.state.ordering ===
                                  FIXED_VULN_ORDERING_2_FOR_NON_EP
                                    ? 'fa fa-sort-amount-down'
                                    : this.state.ordering ===
                                      INV_FIXED_VULN_ORDERING_2_FOR_NON_EP
                                    ? 'fa fa-sort-amount-up'
                                    : 'fa fa-sort'
                                }
                              ></i>
                            )}
                          </th>
                          {/* <th onClick={() => {
                                                    this.orderBy('url')
                                                }}>URL
                                                <i className={this.state.ordering === 'url' ? 'fa fa-sort-amount-down' : (this.state.ordering === '-url' ? 'fa fa-sort-amount-up' : 'fa fa-sort')} ></i>
                                                </th> */}

                          <th
                            onClick={() => {
                              this.orderBy('issue_type');
                            }}
                          >
                            Issue type
                            <i
                              className={
                                this.state.ordering === 'issue_type'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering === '-issue_type'
                                  ? 'fa fa-sort-amount-up'
                                  : 'fa fa-sort'
                              }
                            ></i>
                          </th>
                          <th
                            onClick={() => {
                              this.orderBy('severity');
                            }}
                          >
                            Severity
                            <i
                              className={
                                this.state.ordering === 'severity'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering === '-severity'
                                  ? 'fa fa-sort-amount-up'
                                  : 'fa fa-sort'
                              }
                            ></i>
                          </th>
                          <th>Status</th>
                          <th
                            style={{ minWidth: '150px' }}
                            onClick={() => {
                              this.orderBy('last_detected_date');
                            }}
                          >
                            Last detected date
                            <i
                              className={
                                this.state.ordering === 'last_detected_date'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering ===
                                    '-last_detected_date'
                                  ? 'fa fa-sort-amount-up'
                                  : 'fa fa-sort'
                              }
                            ></i>
                          </th>
                          <th
                            style={{ minWidth: '150px' }}
                            onClick={() => {
                              this.orderBy('last_tested_date');
                            }}
                          >
                            Last tested date
                            <i
                              className={
                                this.state.ordering === 'last_tested_date'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering === '-last_tested_date'
                                  ? 'fa fa-sort-amount-up'
                                  : 'fa fa-sort'
                              }
                            ></i>
                          </th>
                          <th
                            style={{ minWidth: '65px', maxWidth: '65px' }}
                            onClick={() => {
                              this.orderBy('age');
                            }}
                          >
                            <i
                              className="tim-icons icon-alert-circle-exc"
                              id="age-explaination"
                            ></i>{' '}
                            Age
                            <i
                              className={
                                this.state.ordering === 'age'
                                  ? 'fa fa-sort-amount-down'
                                  : this.state.ordering === '-age'
                                  ? 'fa fa-sort-amount-up'
                                  : 'fa fa-sort'
                              }
                            ></i>
                            <UncontrolledTooltip
                              placement="bottom"
                              target={'age-explaination'}
                            >
                              <p style={{ color: 'black', textAlign: 'left' }}>
                                Age shown in fractional days.
                                <br />
                                <strong>Open:</strong> Age since detected.
                                <br />
                                <strong>Closed:</strong> Age at closing.
                              </p>
                            </UncontrolledTooltip>
                          </th>
                          <th className="">Assigned to</th>
                          <th className="">Due Date</th>
                          <th className="text-right finding-buttons-div"></th>
                        </tr>
                      </thead>
                      <tbody>{this.renderReportList.bind(this)()}</tbody>
                    </TableWithStickyHeader>
                  </CardBody>
                )}
                <CardFooter>{this.renderPagination.bind(this)()}</CardFooter>
              </Card>
            </Col>
          </Row>
        </div>
        {this.renderNotification()}
        {this.detailModal()}
        {this.notesModal()}
        {this.renderWatcherModel()}
        {this.renderIgnoreVulnModel()}
        {this.renderUnIgnoreVulnModel()}
        {this.renderAdvanceSearchModel()}
        {this.renderLoader()}
        {status_history_finding_id && (
          <ModalDialog
            title="Vulnerability Status History"
            subTitle={
              this.state.reports.find(
                (x) => x.id === status_history_finding_id,
              )['name'] || ''
            }
            childComponent={
              <StatusDetails findingId={status_history_finding_id} />
            }
            onClose={() => {
              this.setState({ status_history_finding_id: undefined });
            }}
          />
        )}
      </>
    );
  }
}

export { FindingList };
